(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osb-landing"] && !Shopify.designMode) return;
  try {
    
  function loadOsbVimeoApi() {
    if (window.Vimeo?.Player) return Promise.resolve(window.Vimeo);
    if (window.osbVimeoApiPromise) return window.osbVimeoApiPromise;

    window.osbVimeoApiPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector('script[src="https://player.vimeo.com/api/player.js"]');
      const script = existingScript || document.createElement('script');

      script.addEventListener('load', () => resolve(window.Vimeo), { once: true });
      script.addEventListener('error', reject, { once: true });

      if (!existingScript) {
        script.src = 'https://player.vimeo.com/api/player.js';
        script.async = true;
        document.head.appendChild(script);
      }
    });

    return window.osbVimeoApiPromise;
  }

  function initOsbLandings(scope = document) {
    scope.querySelectorAll('[data-osb-landing]:not([data-osb-ready])').forEach((section) => {
      section.setAttribute('data-osb-ready', '');

      const media = section.querySelector('[data-osb-media]');
      const options = section.querySelector('.osb-landing__video-options');
      const nativeTemplate = section.querySelector('[data-osb-native-video]');
      const joinButton = section.querySelector('[data-osb-open]');
      const actions = section.querySelector('[data-osb-actions]');
      const joinPanel = section.querySelector('[data-osb-form]');
      const joinForm = joinPanel?.querySelector('form');
      const requiredFields = joinForm ? Array.from(joinForm.querySelectorAll('input[required]')) : [];
      const signupEndpoint = section.dataset.signupEndpoint;
      const identityServerUrl = String(section.dataset.identityServerUrl || '').replace(/\/$/, '');
      const successWrap = section.querySelector('[data-osb-success]');
      const formErrors = section.querySelector('[data-osb-errors]');
      const intro = section.querySelector('[data-osb-intro]');
      const introTextNode = intro?.querySelector('[data-osb-intro-text]');
      const soundButton = section.querySelector('[data-osb-sound]');
      const secretEntrance = section.querySelector('[data-osb-secret-entrance]');
      const clockScreen = section.querySelector('[data-osb-clock-screen]');
      const clockHeader = section.querySelector('.osb-clock-screen__header');
      const sourceHeader = section.querySelector('.osb-landing__header');
      const hourHand = section.querySelector('[data-osb-clock-hour]');
      const minuteHand = section.querySelector('[data-osb-clock-minute]');
      const countdown = section.querySelector('[data-osb-countdown]');
      const squareCursor = section.querySelector('[data-osb-square-cursor]');
      const award = section.querySelector('[data-osb-award]');
      const joinedStorageKey = 'osb-community-joined';
      let activePlayer = null;
      let activeType = null;
      let soundEnabled = false;
      let introTimer = null;
      let clockFrame = null;
      let previousDocumentOverflow = '';
      let countdownSecond = -1;
      let squareHome = null;
      let squareNextSibling = null;
      let navigationPending = false;
      let actionsGlideAnimation = null;

      function navigateWithFade(url) {
        if (!url || navigationPending) return;
        navigationPending = true;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.location.assign(url);
          return;
        }
        section.classList.add('is-leaving');
        window.setTimeout(() => window.location.assign(url), 430);
      }

      function glideActionsFrom(startRect) {
        if (!actions || !startRect || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        requestAnimationFrame(() => {
          const endRect = actions.getBoundingClientRect();
          const deltaX = startRect.left - endRect.left;
          const deltaY = startRect.top - endRect.top;
          if (Math.abs(deltaX) < 1 && Math.abs(deltaY) < 1) return;

          actionsGlideAnimation?.cancel();
          actionsGlideAnimation = actions.animate(
            [
              { transform: `translate3d(${deltaX}px, ${deltaY}px, 0)` },
              { transform: 'translate3d(0, 0, 0)' }
            ],
            {
              duration: 760,
              easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
              fill: 'both'
            }
          );
          actionsGlideAnimation.addEventListener('finish', () => {
            actionsGlideAnimation = null;
          }, { once: true });
        });
      }

      function showPlayState(keepConfirmationVisible = false) {
        if (!joinButton) return;
        joinButton.dataset.osbJoined = '';
        joinButton.textContent = 'play';
        joinButton.setAttribute('aria-label', 'play chess');
        joinButton.setAttribute('aria-expanded', 'false');
        joinButton.classList.remove('is-form-open', 'is-complete');
        if (keepConfirmationVisible) return;
        actions?.classList.remove('is-form-open');
        joinPanel?.classList.remove('is-open', 'is-submitted');
        if (joinPanel) joinPanel.hidden = true;
      }

      try {
        if (window.localStorage.getItem(joinedStorageKey) === 'true') showPlayState();
      } catch (error) {}

      if (squareCursor && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        section.addEventListener('pointermove', (event) => {
          squareCursor.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0) translate(-50%, -50%)`;
          squareCursor.classList.add('is-visible');
        }, { passive: true });
        section.addEventListener('pointerleave', () => squareCursor.classList.remove('is-visible'));
        window.addEventListener('blur', () => squareCursor.classList.remove('is-visible'));
      }

      const londonFormatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });

      const getLondonParts = (date) => Object.fromEntries(
        londonFormatter
          .formatToParts(date)
          .filter((part) => part.type !== 'literal')
          .map((part) => [part.type, Number(part.value)])
      );

      const londonTimeToDate = (year, month, day, hour, minute = 0, second = 0) => {
        const intendedTime = Date.UTC(year, month - 1, day, hour, minute, second);
        let resultTime = intendedTime;

        for (let attempt = 0; attempt < 3; attempt += 1) {
          const parts = getLondonParts(new Date(resultTime));
          const representedTime = Date.UTC(
            parts.year,
            parts.month - 1,
            parts.day,
            parts.hour,
            parts.minute,
            parts.second
          );
          resultTime += intendedTime - representedTime;
        }

        return new Date(resultTime);
      };

      const getNextWednesday = (now) => {
        const parts = getLondonParts(now);
        const londonDate = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
        let daysUntilWednesday = (3 - londonDate.getUTCDay() + 7) % 7;
        if (daysUntilWednesday === 0) daysUntilWednesday = 7;
        const candidateDate = new Date(Date.UTC(
          parts.year,
          parts.month - 1,
          parts.day + daysUntilWednesday
        ));
        let target = londonTimeToDate(
          candidateDate.getUTCFullYear(),
          candidateDate.getUTCMonth() + 1,
          candidateDate.getUTCDate(),
          0
        );
        return target;
      };

      const pluraliseCountdownUnit = (value, unit) => `${value} ${unit}${value === 1 ? '' : 's'}`;

      const updateCountdown = (now) => {
        if (!countdown) return;
        let remaining = Math.max(0, getNextWednesday(now).getTime() - now.getTime());
        const days = Math.floor(remaining / 86400000);
        remaining %= 86400000;
        const hours = Math.floor(remaining / 3600000);
        remaining %= 3600000;
        const minutes = Math.floor(remaining / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        const secondCopy = window.matchMedia('(max-width: 749px)').matches
          ? ''
          : ` ${pluraliseCountdownUnit(seconds, 'second')}`;
        countdown.textContent = `${pluraliseCountdownUnit(days, 'day')} ${pluraliseCountdownUnit(hours, 'hour')} ${pluraliseCountdownUnit(minutes, 'minute')}${secondCopy} until wednesday.`;
      };
      const updateClock = () => {
        if (clockScreen?.hidden) return;
        const now = new Date();
        const visibleSecond = Math.floor(now.getTime() / 1000);
        if (visibleSecond !== countdownSecond) {
          countdownSecond = visibleSecond;
          updateCountdown(now);
        }
        const seconds = now.getSeconds() + now.getMilliseconds() / 1000;
        const minutes = now.getMinutes() + seconds / 60;
        const hours = (now.getHours() % 12) + minutes / 60;
        if (hourHand) hourHand.style.transform = `translateX(-50%) rotate(${hours * 30}deg)`;
        if (minuteHand) minuteHand.style.transform = `translateX(-50%) rotate(${minutes * 6}deg)`;
        clockFrame = window.requestAnimationFrame(updateClock);
      };

      const syncClockHeader = () => {
        if (!clockHeader || !sourceHeader) return;
        const sourceRect = sourceHeader.getBoundingClientRect();
        clockHeader.style.top = `${sourceRect.top}px`;
        clockHeader.style.left = `${sourceRect.left}px`;
        clockHeader.style.width = `${sourceRect.width}px`;
        clockHeader.style.transform = 'none';
        clockScreen?.style.setProperty('--osb-clock-content-left', `${sourceRect.left}px`);
        clockScreen?.style.setProperty('--osb-clock-content-right', `${window.innerWidth - sourceRect.right}px`);
        clockScreen?.style.setProperty('--osb-clock-header-bottom', `${sourceRect.bottom}px`);
      };

      const openClock = () => {
        if (!clockScreen || !clockScreen.hidden) return;
        previousDocumentOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        syncClockHeader();
        squareHome = secretEntrance?.parentNode || null;
        squareNextSibling = secretEntrance?.nextSibling || null;
        if (secretEntrance && clockHeader) clockHeader.appendChild(secretEntrance);
        clockScreen.hidden = false;
        updateClock();
        secretEntrance?.focus({ preventScroll: true });
      };

      const closeClock = () => {
        if (!clockScreen || clockScreen.hidden) return;
        clockScreen.hidden = true;
        if (secretEntrance && squareHome) squareHome.insertBefore(secretEntrance, squareNextSibling);
        document.documentElement.style.overflow = previousDocumentOverflow;
        if (clockFrame) window.cancelAnimationFrame(clockFrame);
        clockFrame = null;
        secretEntrance?.focus({ preventScroll: true });
      };

      window.addEventListener('resize', () => {
        if (clockScreen && !clockScreen.hidden) syncClockHeader();
      }, { passive: true });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && clockScreen && !clockScreen.hidden) closeClock();
      });

      if (secretEntrance) {
        const desktopHoldDuration = 5000;
  const touchHoldDuration = 3000;
        let holdTimer = null;
        let opened = false;
        let activePointerId = null;

        const cancelSecretHold = (event) => {
          if (event?.type.startsWith('pointer') && activePointerId !== null && event.pointerId !== activePointerId) return false;
          const wasShortPress = Boolean(holdTimer) && !opened;
          if (holdTimer) window.clearTimeout(holdTimer);
          holdTimer = null;
          if (activePointerId !== null && secretEntrance.hasPointerCapture?.(activePointerId)) {
            try { secretEntrance.releasePointerCapture(activePointerId); } catch (error) {}
          }
          activePointerId = null;
          secretEntrance.classList.remove('is-holding');
          return wasShortPress;
        };

        const startSecretHold = (event) => {
          if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
          if (event.type === 'pointerdown' && event.button !== 0) return;
          if (event.cancelable) event.preventDefault();
          if (holdTimer || opened) return;
          if (event.type === 'pointerdown') {
            activePointerId = event.pointerId;
            try { secretEntrance.setPointerCapture(event.pointerId); } catch (error) {}
          }
          const isTouchHold = event.pointerType === 'touch' || event.pointerType === 'pen'
            || window.matchMedia('(pointer: coarse)').matches;
          const holdDuration = isTouchHold ? touchHoldDuration : desktopHoldDuration;
          if (isTouchHold) navigator.vibrate?.(8);
          secretEntrance.classList.add('is-holding');
          holdTimer = window.setTimeout(() => {
            opened = true;
            holdTimer = null;
            navigator.vibrate?.([20, 35, 20]);
            navigateWithFade(secretEntrance.href);
          }, holdDuration);
        };

        const finishSecretHold = (event) => {
          if (event.type === 'keyup' && !['Enter', ' '].includes(event.key)) return;
          if (event.type === 'pointerup' && activePointerId !== null && event.pointerId !== activePointerId) return;
          if (event.cancelable) event.preventDefault();
          if (cancelSecretHold(event)) {
            if (clockScreen?.hidden) openClock();
            else closeClock();
          }
        };

        secretEntrance.addEventListener('click', (event) => event.preventDefault());
        secretEntrance.addEventListener('contextmenu', (event) => event.preventDefault());
        secretEntrance.addEventListener('dragstart', (event) => event.preventDefault());
        secretEntrance.addEventListener('pointerdown', startSecretHold);
        secretEntrance.addEventListener('pointerup', finishSecretHold);
        secretEntrance.addEventListener('pointercancel', cancelSecretHold);
        secretEntrance.addEventListener('selectstart', (event) => event.preventDefault());
        secretEntrance.addEventListener('keydown', startSecretHold);
        secretEntrance.addEventListener('keyup', finishSecretHold);
        secretEntrance.addEventListener('blur', cancelSecretHold);
      }

      const getSignupId = () => {
        const storageKey = 'osb-community-signup-id';
        try {
          const existingId = window.localStorage.getItem(storageKey);
          if (existingId) return existingId;
          const newId = window.crypto?.randomUUID?.()
            || `osb-${Date.now()}-${Math.random().toString(16).slice(2)}`;
          window.localStorage.setItem(storageKey, newId);
          return newId;
        } catch (error) {
          return `osb-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        }
      };

      const candidates = [];
      if (nativeTemplate) candidates.push({ type: 'native' });
      if (options?.dataset.osbWednesdaysVimeo) {
        candidates.push({
          type: 'vimeo-wednesdays',
          id: options.dataset.osbWednesdaysVimeo,
          hash: options.dataset.osbWednesdaysHash
        });
      }
      if (options?.dataset.osbCupVimeo) {
        candidates.push({ type: 'vimeo-cup', id: options.dataset.osbCupVimeo });
      }
      if (options?.dataset.osbKingVimeo) {
        candidates.push({ type: 'vimeo-king', id: options.dataset.osbKingVimeo });
      }

      if (candidates.length && media) {
        const wednesdaysVideo = candidates.find((item) => item.type === 'vimeo-wednesdays');
        const otherVideos = wednesdaysVideo
          ? candidates.filter((item) => item !== wednesdaysVideo)
          : candidates;
        const selected = wednesdaysVideo && Math.random() < 0.75
          ? wednesdaysVideo
          : otherVideos[Math.floor(Math.random() * otherVideos.length)] || wednesdaysVideo || candidates[0];
        activeType = selected.type;
        if (award) award.hidden = selected.type !== 'vimeo-king';

        if (selected.type === 'native') {
          const video = nativeTemplate.content.firstElementChild.cloneNode(true);
          activePlayer = video;
          media.prepend(video);
          video.addEventListener('loadedmetadata', () => {
            if (video.videoWidth && video.videoHeight) {
              media.style.aspectRatio = `${video.videoWidth} / ${video.videoHeight}`;
            }
          }, { once: true });
          video.play().catch(() => {});
        } else if (selected.type === 'vimeo-wednesdays') {
          media.style.aspectRatio = '16 / 9';
          const iframe = document.createElement('iframe');
          iframe.className = 'osb-landing__embed';
          iframe.title = '52 wednesdays deep';
          iframe.allow = 'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share';
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.setAttribute('allowfullscreen', '');
          iframe.tabIndex = -1;

          const hashParameter = selected.hash ? `h=${encodeURIComponent(selected.hash)}&` : '';
          iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(selected.id)}?${hashParameter}badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&muted=1&controls=0&loop=0&background=1&playsinline=1&dnt=1&title=0&byline=0&portrait=0`;
          media.prepend(iframe);

          loadOsbVimeoApi().then(async (Vimeo) => {
            const player = new Vimeo.Player(iframe);
            activePlayer = player;
            let isReplaying = false;

            const chooseRandomStart = async () => {
              const duration = Math.floor(await player.getDuration());
              const earliestStart = duration > 75 ? 51 : 0;
              const latestStart = Math.max(earliestStart, duration - 20);
              const randomStart = Math.floor(earliestStart + Math.random() * (latestStart - earliestStart + 1));
              await player.setCurrentTime(randomStart);
            };

            const replayBeforeEnd = async () => {
              if (isReplaying) return;
              isReplaying = true;
              try {
                await chooseRandomStart();
                await player.play();
              } finally {
                window.setTimeout(() => { isReplaying = false; }, 1000);
              }
            };

            await player.ready();
            await player.setLoop(false);
            await player.setMuted(true);
            try {
              await chooseRandomStart();
            } catch (error) {
              /* Playback should still begin if Vimeo delays seeking on a device. */
            }
            await player.play().catch(() => {});

            player.on('timeupdate', ({ seconds, duration }) => {
              if (duration - seconds <= 8) replayBeforeEnd().catch(() => {});
            });
            player.on('ended', () => replayBeforeEnd().catch(() => {}));
          }).catch(() => {});
        } else if (selected.type === 'vimeo-king') {
          const iframe = document.createElement('iframe');
          iframe.className = 'osb-landing__embed';
          iframe.title = 'king of the city d&ad winner';
          iframe.allow = 'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share';
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.setAttribute('allowfullscreen', '');
          iframe.tabIndex = -1;

          media.style.aspectRatio = '16 / 9';
          iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(selected.id)}?badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&muted=1&controls=0&loop=1&background=1&playsinline=1&dnt=1&title=0&byline=0&portrait=0`;

          activePlayer = iframe;
          media.prepend(iframe);
        } else {
          const iframe = document.createElement('iframe');
          iframe.className = 'osb-landing__embed';
          iframe.title = 'the cscb cup ad';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.tabIndex = -1;

          media.style.aspectRatio = '100 / 60.55';
          iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(selected.id)}?autoplay=1&muted=1&loop=1&autopause=0&background=1&controls=0&dnt=1`;

          activePlayer = iframe;
          media.prepend(iframe);
        }
      }

      function updateSoundLabel() {
        const onLabel = soundButton?.querySelector('[data-osb-sound-on]');
        const offLabel = soundButton?.querySelector('[data-osb-sound-off]');
        if (onLabel) onLabel.hidden = soundEnabled;
        if (offLabel) offLabel.hidden = !soundEnabled;
        soundButton?.setAttribute('aria-pressed', String(soundEnabled));
      }

      function toggleSound() {
        if (!activePlayer || !activeType) return;
        soundEnabled = !soundEnabled;

        if (activeType === 'native') {
          activePlayer.muted = !soundEnabled;
          activePlayer.volume = soundEnabled ? 1 : 0;
          activePlayer.play().catch(() => {});
        } else if (activeType === 'vimeo-wednesdays') {
          if (soundEnabled) {
            activePlayer.setMuted(false);
            activePlayer.setVolume(1);
            activePlayer.play();
          } else {
            activePlayer.setMuted(true);
            activePlayer.setVolume(0);
          }
        } else if (activeType === 'vimeo-cup' || activeType === 'vimeo-king') {
          activePlayer.contentWindow?.postMessage({ method: 'setVolume', value: soundEnabled ? 1 : 0 }, '*');
          if (soundEnabled) activePlayer.contentWindow?.postMessage({ method: 'play' }, '*');
        }

        updateSoundLabel();
      }

      soundButton?.addEventListener('click', (event) => {
        event.stopPropagation();
        toggleSound();
      });

      function updateJoinReadiness() {
        if (!requiredFields.length || !joinButton) return;
        const isReady = requiredFields.every((field) => field.checkValidity());
        joinButton.classList.toggle('is-ready', isReady);
      }

      requiredFields.forEach((field) => {
        field.addEventListener('input', updateJoinReadiness);
        field.addEventListener('change', updateJoinReadiness);
      });

      function dismissIntro() {
        if (introTimer) window.clearTimeout(introTimer);
        intro?.classList.add('is-dismissed');
      }

      function startIntro() {
        if (!intro || !introTextNode) return;
        const text = intro.dataset.text || '';
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const fitIntroText = () => {
          const currentText = introTextNode.textContent;
          intro.style.removeProperty('font-size');
          introTextNode.textContent = text;
          const availableWidth = intro.clientWidth;
          const measuredWidth = introTextNode.getBoundingClientRect().width;
          const maximumSize = Number.parseFloat(window.getComputedStyle(intro).fontSize);

          if (availableWidth && measuredWidth > availableWidth && maximumSize) {
            intro.style.fontSize = `${maximumSize * (availableWidth / measuredWidth) * 0.985}px`;
          }

          introTextNode.textContent = currentText;
        };

        fitIntroText();
        window.addEventListener('resize', fitIntroText, { passive: true });

        if (reduceMotion) {
          introTextNode.textContent = text;
          return;
        }

        let index = 0;
        const typeNextCharacter = () => {
          if (intro.classList.contains('is-dismissed')) return;
          introTextNode.textContent = text.slice(0, index);
          index += 1;

          if (index <= text.length) {
            introTimer = window.setTimeout(typeNextCharacter, 55);
          } else {
            introTimer = null;
          }
        };

        introTimer = window.setTimeout(typeNextCharacter, 550);
      }

      joinButton?.addEventListener('click', () => {
        if (joinButton.hasAttribute('data-osb-joined')) {
          navigateWithFade('/pages/find-a-game');
          return;
        }
        if (!joinPanel) return;

        if (joinPanel.hidden) {
          const actionsStartRect = actions?.getBoundingClientRect();
          dismissIntro();
          joinPanel.hidden = false;
          joinButton.setAttribute('aria-expanded', 'true');
          joinButton.classList.add('is-form-open');
          actions?.classList.add('is-form-open');
          glideActionsFrom(actionsStartRect);
          requestAnimationFrame(() => {
            joinPanel.classList.add('is-open');
            updateJoinReadiness();
          });
        } else if (joinForm && successWrap?.hidden) {
          joinForm.requestSubmit();
        }
      });

      section.querySelectorAll('.osb-landing__wordmark-link, .osb-clock-screen__wordmark-link').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          navigateWithFade(link.href);
        });
      });

      joinForm?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!joinForm.checkValidity()) {
          joinForm.reportValidity();
          return;
        }

        if (!signupEndpoint) {
          if (formErrors) formErrors.textContent = 'try again.';
          return;
        }

        const name = joinForm.querySelector('[name="name"]').value.trim();
        const phone = joinForm.querySelector('[name="phone"]').value.trim();
        const email = joinForm.querySelector('[name="email"]').value.trim();
        const submissionId = getSignupId();
        joinButton?.setAttribute('aria-busy', 'true');
        if (formErrors) formErrors.textContent = '';

        try {
          const payload = { action: 'join', name, phone, email, submissionId };
          if (!identityServerUrl) throw new Error('Profile link unavailable');
          const identityResponse = await fetch(`${identityServerUrl}/api/join`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          if (!identityResponse.ok) throw new Error('Profile link failed');
          const identityData = await identityResponse.json();

          if (identityData.alreadyJoined) {
            const successMessage = successWrap?.querySelector('.osb-landing__success');
            if (successMessage) successMessage.textContent = "you've already joined.";
          } else {
            const response = await fetch(signupEndpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'text/plain;charset=utf-8' },
              body: JSON.stringify(payload)
            });
            if (!response.ok) throw new Error('Signup request failed');
            const data = await response.json();
            if (!data.ok) throw new Error(data.error || 'Signup request failed');
          }

          joinPanel?.classList.add('is-submitted');
          try {
            window.localStorage.setItem(joinedStorageKey, 'true');
          } catch (error) {}

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          await new Promise((resolve) => window.setTimeout(resolve, reduceMotion ? 0 : 540));

          joinForm.hidden = true;
          if (successWrap) successWrap.hidden = false;
          showPlayState(true);
        } catch (error) {
          if (formErrors) formErrors.textContent = 'try again.';
        } finally {
          joinButton?.removeAttribute('aria-busy');
        }
      });

      startIntro();

      section.addEventListener('selectstart', (event) => {
        if (event.target.closest('input, textarea')) return;
        event.preventDefault();
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initOsbLandings());
  } else {
    initOsbLandings();
  }

  document.addEventListener('shopify:section:load', (event) => initOsbLandings(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osb-player-finder"] && !Shopify.designMode) return;
  try {
    
  function loadOsbFinderGoogleIdentity() {
    if (window.google?.accounts?.id) return Promise.resolve(window.google);
    if (window.osbGoogleIdentityPromise) return window.osbGoogleIdentityPromise;
    window.osbGoogleIdentityPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-osb-google-identity]');
      const script = existing || document.createElement('script');
      if (!existing) {
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        script.dataset.osbGoogleIdentity = '';
        document.head.appendChild(script);
      }
      script.addEventListener('load', () => resolve(window.google), { once: true });
      script.addEventListener('error', () => reject(new Error('google sign-in is unavailable')), { once: true });
    });
    return window.osbGoogleIdentityPromise;
  }

  function loadOsbFinderAppleIdentity() {
    if (window.AppleID?.auth) return Promise.resolve(window.AppleID);
    if (window.osbAppleIdentityPromise) return window.osbAppleIdentityPromise;
    window.osbAppleIdentityPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-osb-apple-identity]');
      const script = existing || document.createElement('script');
      if (!existing) {
        script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
        script.async = true;
        script.defer = true;
        script.dataset.osbAppleIdentity = '';
        document.head.appendChild(script);
      }
      script.addEventListener('load', () => resolve(window.AppleID), { once: true });
      script.addEventListener('error', () => reject(new Error('apple sign-in is unavailable')), { once: true });
    });
    return window.osbAppleIdentityPromise;
  }

  function initOsbFinders(scope = document) {
    scope.querySelectorAll('[data-osb-finder]:not([data-osb-finder-ready])').forEach((section) => {
      section.setAttribute('data-osb-finder-ready', '');

      const panel = section.querySelector('[data-osb-finder-panel]');
      const form = section.querySelector('[data-osb-finder-form]');
      const trigger = section.querySelector('[data-osb-finder-trigger]');
      const signinTrigger = section.querySelector('[data-osb-signin-trigger]');
      const actions = section.querySelector('[data-osb-finder-actions]');
      const playButton = section.querySelector('[data-osb-play]');
      const identityLabel = section.querySelector('[data-osb-identity-label]');
      const peopleButton = section.querySelector('[data-osb-people]');
      const requestTriggerButton = section.querySelector('[data-osb-request-trigger]');
      const playChoices = section.querySelector('[data-osb-play-choices]');
      const nameInput = section.querySelector('[data-osb-username]');
      const chessInput = section.querySelector('[data-osb-chess]');
      const cityInput = section.querySelector('[data-osb-city]');
      const cityPlaceIdInput = section.querySelector('[data-osb-city-place-id]');
      const cityOptions = section.querySelector('[data-osb-city-options]');
      const privateLevelInput = section.querySelector('[data-osb-private-level]');
      const profileIntro = section.querySelector('[data-osb-profile-intro]');
      const results = section.querySelector('[data-osb-results]');
      const status = section.querySelector('[data-osb-status]');
      const matches = section.querySelector('[data-osb-matches]');
      const map = section.querySelector('[data-osb-map]');
      const mapCanvas = section.querySelector('[data-osb-map-canvas]');
      const mapMarkers = section.querySelector('[data-osb-map-markers]');
      const directorySelector = section.querySelector('[data-osb-directory-selector]');
      const directoryLabel = section.querySelector('[data-osb-directory-label]');
      const directoryMenu = section.querySelector('[data-osb-directory-menu]');
      const playerSearchWrap = section.querySelector('[data-osb-player-search-wrap]');
      const playerSearch = section.querySelector('[data-osb-player-search]');
      const profileSignin = section.querySelector('[data-osb-profile-signin]');
      const profileGoogle = section.querySelector('[data-osb-profile-google]');
      const profileApple = section.querySelector('[data-osb-profile-apple]');
      const signinIntent = section.querySelector('[data-osb-signin-intent]');
      const profileSigninStatus = section.querySelector('[data-osb-profile-signin-status]');
      const accountTools = section.querySelector('[data-osb-account-tools]');
      const accountRequests = section.querySelector('[data-osb-account-requests]');
      const requestDialog = section.querySelector('[data-osb-request-dialog]');
      const requestTitle = section.querySelector('[data-osb-request-title]');
      const accountStatus = section.querySelector('[data-osb-account-status]');
      const navigationHint = section.querySelector('[data-osb-navigation-hint]');
      const editProfileButton = section.querySelector('[data-osb-edit-profile]');
      const visibilityButton = section.querySelector('[data-osb-directory-visibility]');
      const notificationsButton = section.querySelector('[data-osb-notifications]');
      const emailMatchRequestsButton = section.querySelector('[data-osb-email-match-requests]');
      const feedbackButton = section.querySelector('[data-osb-feedback]');
      const deleteProfileButton = section.querySelector('[data-osb-delete-profile]');
      const signOutButton = section.querySelector('[data-osb-sign-out]');
      const adminOpenButton = section.querySelector('[data-osb-admin-open]');
      const adminDialog = section.querySelector('[data-osb-admin-dialog]');
      const adminCloseButton = section.querySelector('[data-osb-admin-close]');
      const adminSyncButton = section.querySelector('[data-osb-admin-sync]');
      const adminMigrateButton = section.querySelector('[data-osb-admin-migrate]');
      const adminStatus = section.querySelector('[data-osb-admin-status]');
      const adminPlayers = section.querySelector('[data-osb-admin-players]');
      const recommendations = section.querySelector('[data-osb-recommendations]');
      const suggestions = section.querySelector('[data-osb-suggestions]');
      const livePlayButton = section.querySelector('[data-osb-live-play]');
      const computerPlayButton = section.querySelector('[data-osb-computer-play]');
      const learnPlayButton = section.querySelector('[data-osb-learn-play]');
      const returnGameButton = section.querySelector('[data-osb-return-game]');
      const placementBlock = section.querySelector('[data-osb-placement]');
      const placementCopy = section.querySelector('[data-osb-placement-copy]');
      const placementTrack = section.querySelector('[data-osb-placement-track]');
      const liveSection = document.querySelector('[data-osb-live-chess]');
      const liveServerUrl = String(liveSection?.dataset.serverUrl || '').replace(/\/$/, '');
      const googleClientId = String(liveSection?.dataset.googleClientId || '').trim();
      const appleClientId = String(liveSection?.dataset.appleClientId || '').trim();
      const appleRedirectUri = String(liveSection?.dataset.appleRedirectUri || '').trim();
      const accountStorageKey = `osb-live-session:${liveServerUrl}:account`;
      let citySearchTimer = null;
      let citySearchController = null;
      const secretEntrance = section.querySelector('[data-osb-secret-entrance]');
      const clockScreen = section.querySelector('[data-osb-clock-screen]');
      const clockHeader = section.querySelector('.osb-clock-screen__header');
      const sourceHeader = section.querySelector('.osb-finder__header');
      const hourHand = section.querySelector('[data-osb-clock-hour]');
      const minuteHand = section.querySelector('[data-osb-clock-minute]');
      let livePreviewShown = false;
      let livePreviewMode = '';
      const presenceHasStarted = (value) => Boolean(value?.active && value?.started);
      let activeGameWaiting = presenceHasStarted(window.__osbActiveGamePresence);
      if (!activeGameWaiting) {
        try {
          activeGameWaiting = presenceHasStarted(
            JSON.parse(window.sessionStorage.getItem('osb-active-game-presence') || 'null')
          );
        } catch {}
      }
      let liveOpenFrame = null;
      let liveOpenInnerFrame = null;
      let profileSaved = false;
      let accountSession = null;
      let googleTokenClient = null;
      let appleInitialized = false;
      let appleState = '';
      const googleRedirectStateKey = 'osb-google-redirect-state';
      let matcherCloseTimer = null;
      let saveConfirmationTimer = null;
      let deleteConfirmationTimer = null;
      let liveTransitionTimer = null;
      let requestCloseTimer = null;
      let navigationHintTimer = null;
      let navigationPending = false;
      let requestInbox = { incoming: [], friendIncoming: [] };
      let requestedPlayerIds = new Set();
      let outgoingMatchRequests = new Map();
      let requestInboxNotice = '';
      let matchResponseQueryHandled = false;
      let requestPositionFrame = null;
      const requestSoundStorageKey = `${accountStorageKey}:heard-requests`;
      const feedbackStorageKey = 'osb-sound-haptics';
      const locallyClaimedRequestSounds = new Set();
      let requestAudioContext = null;
      let requestAudioUnlocked = false;
      let pendingRequestChime = false;
      let feedbackEnabled = false;
      let presenceSocket = null;
      let presenceConnectPending = false;
      let presencePaused = false;
      let presenceIntentionalClose = false;
      let presenceReconnectTimer = null;
      let presenceReconnectAttempt = 0;

      if (returnGameButton) returnGameButton.hidden = !activeGameWaiting;

      try {
        feedbackEnabled = window.localStorage.getItem(feedbackStorageKey) === 'on';
      } catch {}

      function updateFeedbackButton() {
        if (!feedbackButton) return;
        feedbackButton.textContent = feedbackEnabled ? 'sound + haptics on' : 'sound + haptics off';
        feedbackButton.setAttribute('aria-pressed', String(feedbackEnabled));
        feedbackButton.setAttribute(
          'aria-label',
          feedbackEnabled ? 'turn sound and haptic feedback off' : 'turn sound and haptic feedback on'
        );
      }

      function updateEmailMatchRequestsButton() {
        if (!emailMatchRequestsButton) return;
        const enabled = accountSession?.player?.emailMatchRequests === true;
        emailMatchRequestsButton.hidden = !hasSignedInAccount();
        emailMatchRequestsButton.textContent = enabled
          ? 'email match requests on'
          : 'email match requests off';
        emailMatchRequestsButton.setAttribute('aria-pressed', String(enabled));
        emailMatchRequestsButton.setAttribute(
          'aria-label',
          enabled ? 'turn match request emails off' : 'turn match request emails on'
        );
      }

      function markPending(control, label) {
        if (!control) return;
        control.disabled = true;
        control.classList.remove('is-confirmation', 'is-error');
        control.classList.add('is-pending');
        control.setAttribute('aria-busy', 'true');
        if (label) control.textContent = label;
      }

      function markComplete(control, label, { confirmation = false } = {}) {
        if (!control) return;
        control.disabled = false;
        control.classList.remove('is-pending', 'is-error');
        control.removeAttribute('aria-busy');
        control.classList.toggle('is-confirmation', confirmation);
        if (label) control.textContent = label;
        if (confirmation) {
          window.setTimeout(() => control.classList.remove('is-confirmation'), 1400);
        }
      }

      function markFailed(control, label) {
        if (!control) return;
        control.disabled = false;
        control.classList.remove('is-pending', 'is-confirmation');
        control.classList.add('is-error');
        control.removeAttribute('aria-busy');
        if (label) control.textContent = label;
        window.setTimeout(() => control.classList.remove('is-error'), 1800);
      }

      function claimRequestSound(requestId) {
        const id = String(requestId || '');
        if (!id || locallyClaimedRequestSounds.has(id)) return false;
        const now = Date.now();
        try {
          const stored = JSON.parse(window.localStorage.getItem(requestSoundStorageKey) || '[]');
          const recent = Array.isArray(stored)
            ? stored.filter((item) => item?.id && now - Number(item.at || 0) < 86_400_000)
            : [];
          if (recent.some((item) => item.id === id)) {
            locallyClaimedRequestSounds.add(id);
            return false;
          }
          recent.push({ id, at: now });
          window.localStorage.setItem(requestSoundStorageKey, JSON.stringify(recent.slice(-50)));
        } catch {}
        locallyClaimedRequestSounds.add(id);
        return true;
      }

      function playFeedbackSound(kind = 'success') {
        if (!feedbackEnabled) return;
        if (!requestAudioUnlocked || !requestAudioContext) {
          if (kind === 'notice') pendingRequestChime = true;
          return;
        }
        pendingRequestChime = false;
        const sounds = {
          success: { tones: [523.25, 659.25], gain: 0.022, length: 0.16 },
          notice: { tones: [659.25, 880], gain: 0.032, length: 0.2 },
          error: { tones: [246.94, 196], gain: 0.018, length: 0.18 },
          selection: { tones: [523.25], gain: 0.012, length: 0.08 }
        };
        const sound = sounds[kind] || sounds.success;
        const start = requestAudioContext.currentTime;
        const gain = requestAudioContext.createGain();
        gain.gain.setValueAtTime(0.0001, start);
        gain.gain.exponentialRampToValueAtTime(sound.gain, start + 0.012);
        gain.gain.exponentialRampToValueAtTime(0.0001, start + sound.length);
        gain.connect(requestAudioContext.destination);
        sound.tones.forEach((frequency, index) => {
          const oscillator = requestAudioContext.createOscillator();
          oscillator.type = 'sine';
          oscillator.frequency.value = frequency;
          oscillator.connect(gain);
          oscillator.start(start + (index * 0.045));
          oscillator.stop(start + sound.length);
        });
      }

      function feedbackCue(kind = 'success') {
        if (!feedbackEnabled) return;
        const vibration = {
          success: 8,
          notice: [8, 28, 8],
          error: [12, 32, 12],
          selection: 5
        }[kind] || 8;
        navigator.vibrate?.(vibration);
        playFeedbackSound(kind);
      }

      function feedbackHaptic(pattern = 5) {
        if (!feedbackEnabled) return;
        navigator.vibrate?.(pattern);
      }

      function playRequestChime() {
        feedbackCue('notice');
      }

      async function unlockRequestAudio() {
        if (!feedbackEnabled || requestAudioUnlocked) return;
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        requestAudioContext ||= new AudioContext();
        try {
          await requestAudioContext.resume();
          requestAudioUnlocked = requestAudioContext.state === 'running';
          if (requestAudioUnlocked && pendingRequestChime) playRequestChime();
        } catch {}
      }

      window.__osbFeedback = {
        cue: feedbackCue,
        haptic: feedbackHaptic,
        enabled: () => feedbackEnabled
      };

      function notifyIncomingRequest(request) {
        if (!request || request.recipientId !== accountSession?.player?.id) return;
        if (!claimRequestSound(request.id)) return;
        playRequestChime();
        if (document.hidden && 'Notification' in window && Notification.permission === 'granted') {
          const requestKind = request.kind === 'friend' ? 'friend request' : 'game request';
          try {
            new Notification('one square better', {
              body: `${request.requesterName || 'a player'} sent you a ${requestKind}.`,
              tag: `osb-request-${request.id}`
            });
          } catch {}
        }
      }

      function updateNotificationButton() {
        if (!notificationsButton) return;
        const available = 'Notification' in window;
        notificationsButton.hidden = !available || !hasSignedInAccount();
        if (!available) return;
        notificationsButton.disabled = Notification.permission === 'denied';
        notificationsButton.textContent = Notification.permission === 'granted'
          ? 'notifications on'
          : (Notification.permission === 'denied' ? 'notifications blocked' : 'notifications off');
      }

      function presenceSocketUrl(ticket) {
        const url = new URL(liveServerUrl);
        url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
        url.pathname = '/live';
        url.search = `?ticket=${encodeURIComponent(ticket)}&role=presence`;
        return url.toString();
      }

      function schedulePresenceReconnect() {
        if (
          presencePaused
          || presenceIntentionalClose
          || !hasSignedInAccount()
          || presenceReconnectTimer
        ) return;
        const delay = Math.min(15_000, 900 * (2 ** Math.min(presenceReconnectAttempt, 4)));
        presenceReconnectAttempt += 1;
        presenceReconnectTimer = window.setTimeout(() => {
          presenceReconnectTimer = null;
          connectPresence();
        }, delay);
      }

      async function connectPresence() {
        if (
          presencePaused
          || presenceConnectPending
          || !hasSignedInAccount()
          || !liveServerUrl
          || [WebSocket.OPEN, WebSocket.CONNECTING].includes(presenceSocket?.readyState)
        ) return;
        presenceConnectPending = true;
        presenceIntentionalClose = false;
        const token = accountSession.token;
        try {
          const response = await fetch(`${liveServerUrl}/api/socket-ticket`, {
            method: 'POST',
            headers: { authorization: `Bearer ${token}` }
          });
          const payload = await response.json().catch(() => ({}));
          if (response.status === 401) {
            expireAccountSession();
            return;
          }
          if (!response.ok || !payload.ticket || token !== accountSession?.token || presencePaused) {
            throw new Error(payload.error || 'presence is unavailable');
          }
          const socket = new WebSocket(presenceSocketUrl(payload.ticket));
          presenceSocket = socket;
          socket.addEventListener('open', () => {
            presenceReconnectAttempt = 0;
            refreshDirectory();
          });
          socket.addEventListener('message', (event) => {
            let message;
            try { message = JSON.parse(event.data); }
            catch { return; }
            if (message.type === 'match.requested' || message.type === 'challenge.received') {
              notifyIncomingRequest(message.request);
              loadMatchRequests();
              return;
            }
            if (['friend.requested', 'friend.accepted', 'friend.updated', 'friend.removed', 'friend.blocked', 'friend.unblocked'].includes(message.type)) {
              if (message.type === 'friend.requested') notifyIncomingRequest(message.request);
              loadMatchRequests();
              refreshDirectory();
              return;
            }
            const gameMode = message.game?.metadata?.mode;
            const isActiveLiveGame = (
              (message.type === 'game.start' || message.type === 'game.state')
              && message.game?.status === 'active'
              && gameMode !== 'computer'
              && gameMode !== 'placement'
            );
            if (isActiveLiveGame) {
              loadMatchRequests();
              closeRequestInbox();
              showLivePreview('account');
              return;
            }
            if (
              message.type === 'match.accepted'
              || message.type === 'challenge.declined'
              || message.type === 'challenge.cancelled'
              || message.type === 'challenge.cleared'
            ) loadMatchRequests();
          });
          socket.addEventListener('close', () => {
            if (presenceSocket === socket) presenceSocket = null;
            schedulePresenceReconnect();
            refreshDirectory();
          });
          socket.addEventListener('error', () => socket.close());
        } catch {
          schedulePresenceReconnect();
        } finally {
          presenceConnectPending = false;
        }
      }

      function disconnectPresence() {
        window.clearTimeout(presenceReconnectTimer);
        presenceReconnectTimer = null;
        presenceIntentionalClose = true;
        const socket = presenceSocket;
        presenceSocket = null;
        if (socket && socket.readyState < WebSocket.CLOSING) socket.close(1000, 'presence paused');
      }

      function pausePresenceForGame() {
        presencePaused = true;
        disconnectPresence();
      }

      function resumePresenceAfterGame() {
        presencePaused = false;
        presenceIntentionalClose = false;
        connectPresence();
      }

      function navigateWithFade(url) {
        if (!url || navigationPending) return;
        navigationPending = true;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.location.assign(url);
          return;
        }
        section.classList.add('is-leaving');
        window.setTimeout(() => window.location.assign(url), 310);
      }

      function cancelLiveOpenFrames() {
        if (liveOpenFrame !== null) window.cancelAnimationFrame(liveOpenFrame);
        if (liveOpenInnerFrame !== null) window.cancelAnimationFrame(liveOpenInnerFrame);
        liveOpenFrame = null;
        liveOpenInnerFrame = null;
      }

      function showLivePreview(mode = 'guest', automatic = false) {
        const nextMode = ['account', 'computer', 'learn'].includes(mode) ? mode : 'guest';
        if (livePreviewShown) {
          if (livePreviewMode === nextMode) return;
          if (livePreviewMode !== 'learn' || nextMode !== 'account') return;
          cancelLiveOpenFrames();
          document.dispatchEvent(new CustomEvent('osb:live-chess-close'));
          map?.classList.remove('is-showing-live');
          section.classList.remove('is-playing');
          livePreviewShown = false;
          livePreviewMode = '';
        }
        livePreviewShown = true;
        livePreviewMode = nextMode;
        if (returnGameButton) returnGameButton.hidden = true;
        if (nextMode !== 'learn') pausePresenceForGame();
        window.clearTimeout(liveTransitionTimer);
        playButton?.setAttribute('aria-expanded', 'false');
        section.classList.add('is-playing');
        document.dispatchEvent(new CustomEvent('osb:live-chess-open', {
          detail: {
            preview: true,
            delay: 140,
            autoStart: nextMode === 'computer' || automatic,
            mode: nextMode
          }
        }));
        cancelLiveOpenFrames();
        liveOpenFrame = window.requestAnimationFrame(() => {
          liveOpenFrame = null;
          liveOpenInnerFrame = window.requestAnimationFrame(() => {
            liveOpenInnerFrame = null;
            if (livePreviewShown && livePreviewMode === nextMode) {
              map?.classList.add('is-showing-live');
            }
          });
        });
        const routeHash = nextMode === 'learn' ? '#learn' : '#play';
        if (window.location.hash !== routeHash) {
          window.history.pushState({ osbLiveChess: true, mode: nextMode }, '', routeHash);
        }
      }

      function hideLivePreview() {
        if (!livePreviewShown) return;
        cancelLiveOpenFrames();
        livePreviewShown = false;
        livePreviewMode = '';
        if (returnGameButton) returnGameButton.hidden = !activeGameWaiting;
        hidePlayChoices();
        window.clearTimeout(liveTransitionTimer);
        document.dispatchEvent(new CustomEvent('osb:live-chess-close'));
        window.requestAnimationFrame(() => {
          map?.classList.remove('is-showing-live');
          scheduleStableMapRender();
        });
        const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 640;
        liveTransitionTimer = window.setTimeout(() => {
          if (!livePreviewShown) {
            section.classList.remove('is-playing');
            scheduleStableMapRender();
          }
        }, delay);
        if (!activeGameWaiting) resumePresenceAfterGame();
      }

      function returnToMap() {
        hideLivePreview();
        playButton?.setAttribute('aria-expanded', 'false');
        closeMatcher();
        recommendations?.classList.remove('is-visible');
        if (recommendations) recommendations.hidden = true;
        results?.classList.remove('is-visible');
        if (results) results.hidden = true;
        closeDirectorySelector();
        if (window.location.hash === '#play' || window.location.hash === '#learn') {
          window.history.replaceState({}, '', window.location.pathname + window.location.search);
        }
        updateRequestTrigger();
      }

      document.addEventListener('osb:live-chess-return-map', returnToMap);
      const handleGamePresence = (event) => {
        activeGameWaiting = presenceHasStarted(event?.detail);
        if (returnGameButton) {
          returnGameButton.hidden = !activeGameWaiting || livePreviewShown;
        }
        if (!activeGameWaiting && !livePreviewShown) resumePresenceAfterGame();
      };
      document.addEventListener('osb:game-presence', handleGamePresence);
      const countdown = section.querySelector('[data-osb-countdown]');
      const squareCursor = section.querySelector('[data-osb-finder-cursor]');
      const requiredFields = form ? Array.from(form.querySelectorAll('input[required]')) : [];

      try {
        accountSession = JSON.parse(window.localStorage.getItem(accountStorageKey) || 'null');
      } catch {
        accountSession = null;
      }

      function accountSessionHasExpired(value) {
        try {
          const encodedPayload = String(value?.token || '').split('.')[0];
          const normalizedPayload = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
          const padding = '='.repeat((4 - (normalizedPayload.length % 4)) % 4);
          const bytes = Uint8Array.from(window.atob(normalizedPayload + padding), (character) => character.charCodeAt(0));
          const payload = JSON.parse(new TextDecoder().decode(bytes));
          return !Number.isFinite(payload.exp) || payload.exp <= Date.now();
        } catch {
          return true;
        }
      }

      const sessionExpiredOnLoad = accountSession?.player?.kind === 'account'
        && accountSessionHasExpired(accountSession);
      if (sessionExpiredOnLoad) {
        window.localStorage.removeItem(accountStorageKey);
        accountSession = null;
      }

      function rememberAccount(payload) {
        if (!payload?.token || payload?.player?.kind !== 'account') return;
        accountSession = payload;
        window.localStorage.setItem(accountStorageKey, JSON.stringify(payload));
        const savedProfile = loadSavedProfile(payload.player.id);
        if (nameInput) nameInput.value = payload.player.profileComplete
          ? (payload.player.username || savedProfile?.username || savedProfile?.name || '')
          : (savedProfile?.username || savedProfile?.name || '');
        if (cityInput) {
          cityInput.value = displayCity(payload.player.city || savedProfile?.city || '');
        }
        if (cityPlaceIdInput) {
          cityPlaceIdInput.value = payload.player.cityPlaceId || savedProfile?.cityPlaceId || '';
        }
        if (cityInput) cityInput.dataset.selectedCity = cityPlaceIdInput?.value ? cityInput.value : '';
        if (chessInput) chessInput.value = payload.player.chess || savedProfile?.chess || '';
        const instagramInput = form?.querySelector('[name="instagram_username"]');
        if (instagramInput) instagramInput.value = payload.player.instagram || savedProfile?.instagram || '';
        const level = payload.player.placement?.level || savedProfile?.level || '';
        if (privateLevelInput) privateLevelInput.value = level;
        profileSaved = Boolean(payload.player.profileComplete);
        if (profileSaved) {
          saveLocalProfile({
            ...(savedProfile || {}),
            username: payload.player.username || savedProfile?.username || savedProfile?.name || '',
            name: payload.player.username || savedProfile?.username || savedProfile?.name || '',
            city: String(payload.player.city || savedProfile?.city || '').toLowerCase(),
            cityPlaceId: payload.player.cityPlaceId || savedProfile?.cityPlaceId || '',
            cityCountryCode: payload.player.cityCountryCode || savedProfile?.cityCountryCode || '',
            chess: payload.player.chess || savedProfile?.chess || '',
            instagram: payload.player.instagram || savedProfile?.instagram || '',
            level
          });
        }
        if (payload.player.joined) window.localStorage.setItem('osb-community-joined', 'true');
        updateRequestTrigger();
        if (visibilityButton) {
          visibilityButton.textContent = payload.player.directoryVisible === false ? 'show on map' : 'hide from map';
          visibilityButton.hidden = !profileSaved;
        }
        if (adminOpenButton) adminOpenButton.hidden = payload.player.admin !== true;
        updatePlacementUi();
        updateNotificationButton();
        updateEmailMatchRequestsButton();
        updateFeedbackButton();
        document.dispatchEvent(new CustomEvent('osb:account-session', { detail: payload }));
        window.setTimeout(() => {
          if (hasSignedInAccount()) {
            connectPresence();
            refreshDirectory();
            loadMatchRequests();
          }
        }, 0);
      }

      function showNavigationHint() {
        if (!navigationHint) return;
        const playerId = String(accountSession?.player?.id || 'guest');
        const hintKey = `osb-navigation-hint-seen:${playerId}`;
        try {
          if (window.localStorage.getItem(hintKey) === 'true') return;
          window.localStorage.setItem(hintKey, 'true');
        } catch {}
        window.clearTimeout(navigationHintTimer);
        navigationHint.hidden = false;
        window.requestAnimationFrame(() => navigationHint.classList.add('is-visible'));
        navigationHintTimer = window.setTimeout(() => {
          navigationHint.classList.remove('is-visible');
          window.setTimeout(() => {
            if (!navigationHint.classList.contains('is-visible')) navigationHint.hidden = true;
          }, 180);
        }, 9000);
      }

      function profileStorageKey(playerId = accountSession?.player?.id) {
        return playerId ? `osb-profile:${playerId}` : '';
      }

      function loadSavedProfile(playerId = accountSession?.player?.id) {
        const key = profileStorageKey(playerId);
        if (!key) return null;
        try { return JSON.parse(window.localStorage.getItem(key) || 'null'); }
        catch { return null; }
      }

      function saveLocalProfile(profile) {
        const key = profileStorageKey();
        if (key) window.localStorage.setItem(key, JSON.stringify(profile));
      }

      function showProfileForm() {
        hidePlayChoices();
        if (profileSignin) profileSignin.hidden = true;
        if (form) form.hidden = false;
        if (accountTools) accountTools.hidden = false;
        panel?.classList.remove('is-auth-mode');
        actions?.classList.remove('is-auth-open');
        trigger?.classList.remove('is-auth-active');
        if (trigger) trigger.textContent = 'save';
        if (accountStatus) accountStatus.textContent = '';
        if (profileIntro) profileIntro.textContent = profileSaved
          ? 'your one square better profile.'
          : 'make your one square better profile.';
        if (nameInput && profileSaved && accountSession?.player?.username && !nameInput.value) {
          nameInput.value = accountSession.player.username;
        }
        updateReadiness();
      }

      function showSignin() {
        hidePlayChoices();
        if (form) form.hidden = true;
        if (accountTools) accountTools.hidden = true;
        if (adminOpenButton) adminOpenButton.hidden = true;
        adminDialog?.close();
        resetDeleteConfirmation();
        if (profileSignin) profileSignin.hidden = false;
        panel?.classList.add('is-auth-mode');
        actions?.classList.add('is-auth-open');
        if (signinIntent) signinIntent.textContent = 'sign in with';
        if (trigger) trigger.textContent = 'sign in';
        trigger?.classList.add('is-auth-active');
        prepareGoogleButton();
        prepareAppleButton();
      }

      async function createProviderAccount(mode, credential) {
        if (!liveServerUrl) throw new Error('sign in is unavailable');
        const response = await fetch(`${liveServerUrl}/api/session`, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ mode, credential })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.error || 'could not sign in');
        rememberAccount(payload);
        showNavigationHint();
        if (profileSaved) {
          closeMatcher();
          updateRequestTrigger();
          return;
        }
        showProfileForm();
        window.setTimeout(() => nameInput?.focus(), 100);
      }

      function startGoogleRedirect() {
        if (!googleClientId) {
          if (profileSigninStatus) profileSigninStatus.textContent = 'sign in is unavailable';
          return;
        }
        const randomBytes = new Uint8Array(18);
        window.crypto.getRandomValues(randomBytes);
        const state = Array.from(randomBytes, (value) => value.toString(16).padStart(2, '0')).join('');
        window.sessionStorage.setItem(googleRedirectStateKey, state);
        const redirectUri = `${window.location.origin}${window.location.pathname}`;
        const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth');
        authUrl.searchParams.set('client_id', googleClientId);
        authUrl.searchParams.set('redirect_uri', redirectUri);
        authUrl.searchParams.set('response_type', 'token');
        authUrl.searchParams.set('scope', 'openid email profile');
        authUrl.searchParams.set('include_granted_scopes', 'true');
        authUrl.searchParams.set('prompt', 'select_account');
        authUrl.searchParams.set('state', state);
        window.location.assign(authUrl.toString());
      }

      async function consumeGoogleRedirect() {
        const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
        if (!params.has('access_token') && !params.has('error')) return;
        const expectedState = window.sessionStorage.getItem(googleRedirectStateKey) || '';
        window.sessionStorage.removeItem(googleRedirectStateKey);
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
        openMatcher(false);
        if (params.has('error')) {
          if (profileSigninStatus) profileSigninStatus.textContent = 'google sign-in did not complete';
          return;
        }
        if (!expectedState || params.get('state') !== expectedState) {
          if (profileSigninStatus) profileSigninStatus.textContent = 'google sign-in could not be verified';
          return;
        }
        try {
          await createProviderAccount('google_access', params.get('access_token'));
        } catch (error) {
          if (profileSigninStatus) profileSigninStatus.textContent = error.message;
        }
      }

      async function prepareGoogleButton() {
        if (!profileGoogle) return;
        if (!googleClientId) {
          if (profileSigninStatus) profileSigninStatus.textContent = 'sign in is unavailable';
          return;
        }
        try {
          const google = await loadOsbFinderGoogleIdentity();
          if (!googleTokenClient) {
            googleTokenClient = google.accounts.oauth2.initTokenClient({
              client_id: googleClientId,
              scope: 'openid email profile',
              callback: (response) => {
                if (response?.error) {
                  if (profileSigninStatus) profileSigninStatus.textContent = 'google sign-in did not complete';
                  return;
                }
                if (!response?.access_token) return;
                if (profileSigninStatus) profileSigninStatus.textContent = '';
                createProviderAccount('google_access', response.access_token).catch((error) => {
                  if (profileSigninStatus) profileSigninStatus.textContent = error.message;
                });
              }
            });
          }
          profileGoogle.disabled = false;
        } catch (error) {
          profileGoogle.disabled = true;
          if (profileSigninStatus) profileSigninStatus.textContent = error.message;
        }
      }

      async function prepareAppleButton() {
        if (!profileApple) return;
        if (!appleClientId || !appleRedirectUri) {
          profileApple.disabled = true;
          return;
        }
        try {
          const apple = await loadOsbFinderAppleIdentity();
          if (!appleInitialized) {
            const randomBytes = new Uint8Array(18);
            window.crypto.getRandomValues(randomBytes);
            appleState = Array.from(randomBytes, (value) => value.toString(16).padStart(2, '0')).join('');
            apple.auth.init({
              clientId: appleClientId,
              scope: 'name email',
              redirectURI: appleRedirectUri,
              state: appleState,
              usePopup: true
            });
            appleInitialized = true;
          }
          profileApple.disabled = false;
        } catch (error) {
          profileApple.disabled = true;
          if (profileSigninStatus) profileSigninStatus.textContent = error.message;
        }
      }

      const handleAppleSuccess = async (event) => {
        try {
          if (profileSigninStatus) profileSigninStatus.textContent = '';
          const response = event.detail?.data || event.detail;
          if (!response || response.authorization?.state !== appleState) throw new Error('apple sign-in could not be verified');
          const credential = response?.authorization?.id_token;
          if (!credential) throw new Error('apple sign-in did not complete');
          await createProviderAccount('apple', credential);
        } catch (error) {
          if (profileSigninStatus) profileSigninStatus.textContent = error?.message || 'apple sign-in did not complete';
        }
      };

      const handleAppleFailure = (event) => {
        const code = event.detail?.error || event.detail?.data?.error;
        if (code === 'user_cancelled_authorize') return;
        if (profileSigninStatus) profileSigninStatus.textContent = 'apple sign-in did not complete';
      };

      document.addEventListener('AppleIDSignInOnSuccess', handleAppleSuccess);
      document.addEventListener('AppleIDSignInOnFailure', handleAppleFailure);

      profileGoogle?.addEventListener('click', () => {
        const shouldRedirect = window.matchMedia('(max-width: 749px)').matches
          || navigator.maxTouchPoints > 0
          || !googleTokenClient;
        if (shouldRedirect) {
          if (profileSigninStatus) profileSigninStatus.textContent = 'opening google…';
          startGoogleRedirect();
          return;
        }
        if (profileSigninStatus) profileSigninStatus.textContent = 'opening google…';
        googleTokenClient.requestAccessToken({ prompt: 'select_account' });
      });

      profileApple?.addEventListener('click', async () => {
        if (!appleInitialized) {
          if (profileSigninStatus) profileSigninStatus.textContent = 'apple is still loading. tap again.';
          prepareAppleButton();
          return;
        }
        try {
          if (profileSigninStatus) profileSigninStatus.textContent = 'opening apple…';
          await window.AppleID.auth.signIn();
        } catch (error) {
          if (error?.error === 'popup_closed_by_user' || error?.error === 'user_cancelled_authorize') return;
          if (profileSigninStatus) profileSigninStatus.textContent = 'apple sign-in did not complete';
        }
      });

      consumeGoogleRedirect();

      const normalizeUsername = (value) => value.replace(/^@/, '').trim();
      const normalizeCity = (value) => value.toLowerCase().replace(/[^a-z0-9]/g, '');
      const countryOnlyCityLabels = new Set([
        'gb',
        'uk',
        'united kingdom',
        'great britain',
        'england',
        'scotland',
        'wales',
        'northern ireland'
      ]);
      const displayCity = (value) => {
        const parts = String(value || '')
          .split(',')
          .map((part) => part.trim().toLowerCase())
          .filter(Boolean);
        if (parts[0]?.startsWith('city of ') && parts[1]) return parts[1];
        if (parts.length === 1 && countryOnlyCityLabels.has(parts[0])) return '';
        return parts[0] || '';
      };
      const levelOrder = ['i dabble', "i'm aight", 'bang out'];
      let directoryProfiles = [];
      let selectedDirectoryLabel = '';
      let selectedDirectoryMode = '';
      let selectedDirectoryPlayerIds = new Set();
      let playerSearchQuery = '';
      let directoryRefreshPending = false;

      function hasSignedInAccount() {
        return Boolean(
          accountSession?.token
          && accountSession?.player?.kind === 'account'
          && !accountSessionHasExpired(accountSession)
        );
      }

      function clearMemberDirectory() {
        directoryProfiles = [];
        selectedDirectoryLabel = '';
        selectedDirectoryMode = '';
        selectedDirectoryPlayerIds.clear();
        playerSearchQuery = '';
        if (playerSearch) playerSearch.value = '';
        if (playerSearchWrap) playerSearchWrap.hidden = true;
        if (directorySelector) {
          directorySelector.open = false;
          directorySelector.hidden = true;
        }
        if (directoryLabel) {
          directoryLabel.textContent = '';
          directoryLabel.hidden = true;
        }
        directoryMenu?.replaceChildren();
        if (status) {
          status.textContent = '';
          status.hidden = true;
        }
        renderMapMarkers([]);
        matches?.replaceChildren();
        suggestions?.replaceChildren();
        recommendations?.classList.remove('is-visible');
        if (recommendations) recommendations.hidden = true;
        results?.classList.remove('is-visible');
        if (results) results.hidden = true;
        peopleButton?.setAttribute('aria-expanded', 'false');
      }

      function closeDirectorySelector() {
        return directorySelector;
      }

      function directorySelectionKey() {
        return selectedDirectoryMode;
      }

      function selectedDirectoryProfiles() {
        if (selectedDirectoryMode === 'all') {
          return directoryProfiles.filter((profile) => (
            profile.osbPlayerId !== accountSession?.player?.id
            && profile.friendship !== 'blocked'
          ));
        }
        if (selectedDirectoryMode === 'friends') {
          return directoryProfiles.filter((profile) => profile.friendship === 'friend');
        }
        if (selectedDirectoryMode === 'find') {
          const query = playerSearchQuery.trim().toLowerCase();
          if (query.length < 2) return [];
          return directoryProfiles.filter((profile) => (
            profile.osbPlayerId !== accountSession?.player?.id
            && String(profile.name || '').toLowerCase().includes(query)
          ));
        }
        if (selectedDirectoryMode === 'area') {
          return directoryProfiles.filter((profile) => selectedDirectoryPlayerIds.has(profile.osbPlayerId));
        }
        return [];
      }

      function closeDirectoryView({ returnFocus = false } = {}) {
        selectedDirectoryMode = '';
        selectedDirectoryLabel = '';
        selectedDirectoryPlayerIds.clear();
        playerSearchQuery = '';
        if (playerSearch) playerSearch.value = '';
        if (playerSearchWrap) playerSearchWrap.hidden = true;
        if (directoryLabel) {
          directoryLabel.textContent = '';
          directoryLabel.hidden = true;
        }
        if (directorySelector) directorySelector.hidden = true;
        if (status) {
          status.textContent = '';
          status.hidden = true;
        }
        matches?.replaceChildren();
        results?.classList.remove('is-visible');
        if (results) results.hidden = true;
        peopleButton?.setAttribute('aria-expanded', 'false');
        if (returnFocus) peopleButton?.focus();
      }

      function selectDirectoryView(mode, label, profiles = []) {
        if (!hasSignedInAccount()) return;
        closeCityOptions();
        if (panel?.classList.contains('is-open')) resetMatcherLayout({ immediate: true });
        selectedDirectoryMode = mode;
        selectedDirectoryPlayerIds = new Set(
          mode === 'area' ? profiles.map((profile) => profile.osbPlayerId).filter(Boolean) : []
        );
        selectedDirectoryLabel = label;
        closeDirectorySelector();
        showProfileCards(selectedDirectoryProfiles(), label);
      }

      function renderDirectoryMenu() {
        if (!directoryMenu) return;
        directoryMenu.replaceChildren();
        if (!hasSignedInAccount()) return;

        const currentKey = directorySelectionKey();
        const options = [
          {
            key: 'all',
            mode: 'all',
            label: 'players'
          },
          {
            key: 'friends',
            mode: 'friends',
            label: 'friends'
          },
          {
            key: 'find',
            mode: 'find',
            label: 'find'
          },
          {
            key: 'profile',
            label: 'profile',
            action: () => {
              closeDirectoryView();
              hideLivePreview();
              openMatcher(true);
            }
          }
        ];

        options.forEach((option) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `osb-finder__directory-option osb-finder__directory-option--${option.key}`;
          button.setAttribute('aria-current', String(option.key === currentKey));
          const label = document.createElement('span');
          label.textContent = option.label;
          button.append(label);
          button.addEventListener('click', () => {
            if (option.action) {
              option.action();
              return;
            }
            selectDirectoryView(option.mode, option.label);
          });
          directoryMenu.appendChild(button);
        });
      }

      function updatePlacementUi() {
        if (!placementBlock || !placementTrack) return;
        const placement = accountSession?.player?.placement;
        placementBlock.hidden = !placement || placement.complete;
        if (!placement || placement.complete) return;
        const completed = Number(placement.completed || 0);
        const total = Number(placement.total || 5);
        placementTrack.setAttribute('aria-label', `${completed} of ${total} placement games complete`);
        Array.from(placementTrack.children).forEach((square, index) => {
          square.classList.toggle('is-complete', index < completed);
        });
        if (placementCopy) {
          placementCopy.textContent = `placement ${completed} of ${total}`;
        }
      }

      async function refreshAccountSession() {
        if (!accountSession?.token || !liveServerUrl) return;
        try {
          const response = await fetch(`${liveServerUrl}/api/profile`, {
            headers: { authorization: `Bearer ${accountSession.token}` }
          });
          if (response.status === 401) return expireAccountSession();
          const payload = await response.json();
          if (response.ok) rememberAccount(payload);
        } catch (error) {}
      }

      if (accountSession?.player?.kind === 'account') {
        rememberAccount(accountSession);
        refreshAccountSession();
      } else {
        if (trigger) trigger.textContent = 'join';
        if (sessionExpiredOnLoad && profileSigninStatus) {
          profileSigninStatus.textContent = 'session expired. sign in again.';
        }
        if (playButton) {
          playButton.textContent = 'guest';
          playButton.setAttribute('aria-label', 'play as guest');
        }
      }

      const matchResponseUrl = new URL(window.location.href);
      if (matchResponseUrl.searchParams.has('request') || matchResponseUrl.searchParams.has('response')) {
        if (accountSession?.player?.kind === 'account') {
          applyMatchResponseQuery();
        } else {
          openMatcher(false);
          showSignin();
        }
      }

      let squareCursorFrame = null;
      let squareCursorPoint = null;
      const hideSquareCursor = () => {
        squareCursorPoint = null;
        if (squareCursorFrame) window.cancelAnimationFrame(squareCursorFrame);
        squareCursorFrame = null;
        squareCursor?.classList.remove('is-visible');
      };
      const paintSquareCursor = () => {
        squareCursorFrame = null;
        if (!squareCursor || !squareCursorPoint) return;
        squareCursor.style.transform = `translate3d(${squareCursorPoint.x}px, ${squareCursorPoint.y}px, 0) translate(-50%, -50%)`;
        squareCursor.classList.add('is-visible');
      };
      if (squareCursor && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        section.addEventListener('pointermove', (event) => {
          const liveBoard = event.target instanceof Element
            ? event.target.closest('.osb-live__board-shell')
            : null;
          if (!liveBoard || (event.pointerType && event.pointerType !== 'mouse')) {
            hideSquareCursor();
            return;
          }
          squareCursorPoint = { x: event.clientX, y: event.clientY };
          if (!squareCursorFrame) squareCursorFrame = window.requestAnimationFrame(paintSquareCursor);
        }, { passive: true });
        section.addEventListener('pointerleave', hideSquareCursor);
        section.addEventListener('pointercancel', hideSquareCursor);
        window.addEventListener('blur', hideSquareCursor);
      }
      let clockFrame = null;
      let previousDocumentOverflow = '';
      let countdownSecond = -1;
      let squareHome = null;
      let squareNextSibling = null;

      const londonFormatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });

      const getLondonParts = (date) => Object.fromEntries(
        londonFormatter
          .formatToParts(date)
          .filter((part) => part.type !== 'literal')
          .map((part) => [part.type, Number(part.value)])
      );

      const londonTimeToDate = (year, month, day, hour, minute = 0, second = 0) => {
        const intendedTime = Date.UTC(year, month - 1, day, hour, minute, second);
        let resultTime = intendedTime;

        for (let attempt = 0; attempt < 3; attempt += 1) {
          const parts = getLondonParts(new Date(resultTime));
          const representedTime = Date.UTC(
            parts.year,
            parts.month - 1,
            parts.day,
            parts.hour,
            parts.minute,
            parts.second
          );
          resultTime += intendedTime - representedTime;
        }

        return new Date(resultTime);
      };

      const getNextWednesday = (now) => {
        const parts = getLondonParts(now);
        const londonDate = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
        let daysUntilWednesday = (3 - londonDate.getUTCDay() + 7) % 7;
        if (daysUntilWednesday === 0) daysUntilWednesday = 7;
        const candidateDate = new Date(Date.UTC(
          parts.year,
          parts.month - 1,
          parts.day + daysUntilWednesday
        ));
        let target = londonTimeToDate(
          candidateDate.getUTCFullYear(),
          candidateDate.getUTCMonth() + 1,
          candidateDate.getUTCDate(),
          0
        );
        return target;
      };

      const pluraliseCountdownUnit = (value, unit) => `${value} ${unit}${value === 1 ? '' : 's'}`;

      const updateCountdown = (now) => {
        if (!countdown) return;
        let remaining = Math.max(0, getNextWednesday(now).getTime() - now.getTime());
        const days = Math.floor(remaining / 86400000);
        remaining %= 86400000;
        const hours = Math.floor(remaining / 3600000);
        remaining %= 3600000;
        const minutes = Math.floor(remaining / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        const secondCopy = window.matchMedia('(max-width: 749px)').matches
          ? ''
          : ` ${pluraliseCountdownUnit(seconds, 'second')}`;
        countdown.textContent = `${pluraliseCountdownUnit(days, 'day')} ${pluraliseCountdownUnit(hours, 'hour')} ${pluraliseCountdownUnit(minutes, 'minute')}${secondCopy} until wednesday.`;
      };

      const updateClock = () => {
        if (clockScreen?.hidden) return;
        const now = new Date();
        const visibleSecond = Math.floor(now.getTime() / 1000);
        if (visibleSecond !== countdownSecond) {
          countdownSecond = visibleSecond;
          updateCountdown(now);
        }
        const seconds = now.getSeconds() + now.getMilliseconds() / 1000;
        const minutes = now.getMinutes() + seconds / 60;
        const hours = (now.getHours() % 12) + minutes / 60;
        if (hourHand) hourHand.style.transform = `translateX(-50%) rotate(${hours * 30}deg)`;
        if (minuteHand) minuteHand.style.transform = `translateX(-50%) rotate(${minutes * 6}deg)`;
        clockFrame = window.requestAnimationFrame(updateClock);
      };

      const syncClockHeader = () => {
        if (!clockHeader || !sourceHeader) return;
        const sourceRect = sourceHeader.getBoundingClientRect();
        clockHeader.style.top = `${sourceRect.top}px`;
        clockHeader.style.left = `${sourceRect.left}px`;
        clockHeader.style.width = `${sourceRect.width}px`;
        clockHeader.style.transform = 'none';
        clockScreen?.style.setProperty('--osb-clock-content-left', `${sourceRect.left}px`);
        clockScreen?.style.setProperty('--osb-clock-content-right', `${window.innerWidth - sourceRect.right}px`);
        clockScreen?.style.setProperty('--osb-clock-header-bottom', `${sourceRect.bottom}px`);
      };

      const openClock = () => {
        if (!clockScreen || !clockScreen.hidden) return;
        previousDocumentOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        syncClockHeader();
        squareHome = secretEntrance?.parentNode || null;
        squareNextSibling = secretEntrance?.nextSibling || null;
        if (secretEntrance && clockHeader) clockHeader.appendChild(secretEntrance);
        clockScreen.hidden = false;
        updateClock();
        secretEntrance?.focus({ preventScroll: true });
      };

      const closeClock = () => {
        if (!clockScreen || clockScreen.hidden) return;
        clockScreen.hidden = true;
        if (secretEntrance && squareHome) squareHome.insertBefore(secretEntrance, squareNextSibling);
        document.documentElement.style.overflow = previousDocumentOverflow;
        if (clockFrame) window.cancelAnimationFrame(clockFrame);
        clockFrame = null;
        secretEntrance?.focus({ preventScroll: true });
      };

      section.querySelectorAll('.osb-finder__wordmark-link, .osb-clock-screen__wordmark-link').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (clockScreen && !clockScreen.hidden) closeClock();
          if (link.matches('.osb-finder__wordmark-link--home, .osb-clock-screen__wordmark-link--home')) {
            navigateWithFade(link.href);
            return;
          }
          returnToMap();
        });
      });

      window.addEventListener('resize', () => {
        if (clockScreen && !clockScreen.hidden) syncClockHeader();
      }, { passive: true });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && clockScreen && !clockScreen.hidden) closeClock();
      });

      if (secretEntrance) {
        const desktopHoldDuration = 3000;
        const touchHoldDuration = 3000;
        let holdTimer = null;
        let opened = false;
        let activePointerId = null;

        const cancelSecretHold = (event) => {
          if (event?.type.startsWith('pointer') && activePointerId !== null && event.pointerId !== activePointerId) return false;
          const wasShortPress = Boolean(holdTimer) && !opened;
          if (holdTimer) window.clearTimeout(holdTimer);
          holdTimer = null;
          if (activePointerId !== null && secretEntrance.hasPointerCapture?.(activePointerId)) {
            try { secretEntrance.releasePointerCapture(activePointerId); } catch (error) {}
          }
          activePointerId = null;
          secretEntrance.classList.remove('is-holding');
          return wasShortPress;
        };

        const startSecretHold = (event) => {
          if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
          if (event.type === 'pointerdown' && event.button !== 0) return;
          if (event.cancelable) event.preventDefault();
          if (holdTimer || opened) return;
          if (event.type === 'pointerdown') {
            activePointerId = event.pointerId;
            try { secretEntrance.setPointerCapture(event.pointerId); } catch (error) {}
          }
          const isTouchHold = event.pointerType === 'touch' || event.pointerType === 'pen'
            || window.matchMedia('(pointer: coarse)').matches;
          const holdDuration = isTouchHold ? touchHoldDuration : desktopHoldDuration;
          if (isTouchHold) feedbackHaptic(8);
          secretEntrance.classList.add('is-holding');
          holdTimer = window.setTimeout(() => {
            opened = true;
            holdTimer = null;
            feedbackHaptic([20, 35, 20]);
            navigateWithFade(secretEntrance.href);
          }, holdDuration);
        };

        const finishSecretHold = (event) => {
          if (event.type === 'keyup' && !['Enter', ' '].includes(event.key)) return;
          if (event.type === 'pointerup' && activePointerId !== null && event.pointerId !== activePointerId) return;
          if (event.cancelable) event.preventDefault();
          if (cancelSecretHold(event)) {
            if (clockScreen?.hidden) openClock();
            else closeClock();
          }
        };

        secretEntrance.addEventListener('click', (event) => event.preventDefault());
        secretEntrance.addEventListener('contextmenu', (event) => event.preventDefault());
        secretEntrance.addEventListener('dragstart', (event) => event.preventDefault());
        secretEntrance.addEventListener('pointerdown', startSecretHold);
        secretEntrance.addEventListener('pointerup', finishSecretHold);
        secretEntrance.addEventListener('pointercancel', cancelSecretHold);
        secretEntrance.addEventListener('selectstart', (event) => event.preventDefault());
        secretEntrance.addEventListener('keydown', startSecretHold);
        secretEntrance.addEventListener('keyup', finishSecretHold);
        secretEntrance.addEventListener('blur', cancelSecretHold);
      }

      const worldMask = [
        '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
        '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
        '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
        '000000000000000000000001011111111111110000000000000000000000000000000000000000000000000000000000',
        '000000000000000000000001110111111111100000000000000000000000110000000000000000000000000000000000',
        '000000000000001111111111100001111111000000000000000000000111111111100000000000000000000000000000',
        '000011111111111111111111110001111110000000001111000011111111111111111111111111110000000000000000',
        '000111111111111111111101110011111001100000011111111111111111111111111111111111111100000000000000',
        '001111111111111111110011100011100000000001111111111111111111111111111111111111111000000000000000',
        '011110111111111111000111100000000000000001110111111111111111111111111111111110110000000000000000',
        '000000011111111111100111100000000000001100110111111111111111111111111111110000110000000000000000',
        '000000011111111111101111110000000000011101111111111111111111111111111111111100010000000000000000',
        '000000011111111111111111110000000000000111111111111111111111111111111111111110000000000000000000',
        '000000011111111111111110010000000000000111111111111111111111111111111111111100000000000000000000',
        '000000111111111111111110000000000000011111111111001111111111111111111111111101100000000000000000',
        '000000111111111111110000000000000000011100010111111110111111111111111111111000000000000000000000',
        '000001111111111111100000000000000000011100000101111110111111111111111111101000100000000000000000',
        '000000111111111111000000000000000000001111100000011111111111111111111111110111100000000000000000',
        '000000111111111110000000000000000000011111110110111111111111111111111111110010000000000000000000',
        '000000111111110110000000000000000000111111111111111111111111111111111111110000000000000000000000',
        '000000011111000010000000000000000001111111111111111111011111111111111111110000000000000000000000',
        '000000001110000000000000000000000011111111111111111111111001111111111111111000000000000000000000',
        '000000000110010001100000000000000011111111111111111111111000111110111110000000000000000000000000',
        '000000000011110000000000000000000011111111111111111011110000011100011110000000000000000000000000',
        '000000000000111000000000000000000011111111111111111111000000011000001111000000000000000000000000',
        '000000000000001001110000000000000001111111111111111111100000001000000011000000000000000000000000',
        '000000000000000011111100000000000001111111111111111111000000000100000000000010000000000000000000',
        '000000000000000011111111000000000000111101111111111111000000000000001100011000000000000000000000',
        '000000000000000011111111100000000000000000111111111110000000000000001100111000000000000000000000',
        '000000000000000111111111110000000000000000111111111100000000000000000100110100000000000000000000',
        '000000000000000111111111111100000000000000111111111000000000000000000010110100011110000000000000',
        '000000000000000111111111111110000000000000011111111000000000000000000001100000001110000000000000',
        '000000000000000011111111111110000000000000011111111000000000000000000000000000000001000000000000',
        '000000000000000001111111111100000000000000011111111100000000000000000000000000110100000000000000',
        '000000000000000001111111111100000000000000011111111001000000000000000000000011110100000000000000',
        '000000000000000000011111111100000000000000011111110011000000000000000000000111111110000000000000',
        '000000000000000000011111111100000000000000011111110011000000000000000000011111111110000000000000',
        '000000000000000000011111110000000000000000011111110010000000000000000000111111111111000000000000',
        '000000000000000000011111110000000000000000001111100000000000000000000000111111111111000000000000',
        '000000000000000000011111100000000000000000001111000000000000000000000000111111111110000000000000',
        '000000000000000000011111100000000000000000000111000000000000000000000000111001111110000000000000',
        '000000000000000000011111000000000000000000000000000000000000000000000000000000111100000010000000',
        '000000000000000000011110000000000000000000000000000000000000000000000000000000000000000110000000',
        '000000000000000000001110000000000000000000000000000000000000000000000000000000010000001000000000',
        '000000000000000000001100000000000000000000000000000000000000000000000000000000000000100000000000',
        '000000000000000000001110000000000000000000000000000000000000000000000000000000000000000000000000',
        '000000000000000000000100000000000000000000000000000000000000000000000000000000000000000000000000',
        '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
        '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
        '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
        '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
        '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
        '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
        '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000'
      ];

      function cellHasLand(column, row, columns, rows) {
        const sourceRows = worldMask.length;
        const sourceColumns = worldMask[0].length;
        const left = Math.floor(column * sourceColumns / columns);
        const right = Math.max(left + 1, Math.ceil((column + 1) * sourceColumns / columns));
        const top = Math.floor(row * sourceRows / rows);
        const bottom = Math.max(top + 1, Math.ceil((row + 1) * sourceRows / rows));
        let landCells = 0;
        let sampledCells = 0;

        for (let sourceRow = top; sourceRow < bottom; sourceRow += 1) {
          for (let sourceColumn = left; sourceColumn < right; sourceColumn += 1) {
            sampledCells += 1;
            if (worldMask[sourceRow]?.[sourceColumn] === '1') landCells += 1;
          }
        }

        const centreRow = Math.min(sourceRows - 1, Math.floor((row + 0.5) * sourceRows / rows));
        const centreColumn = Math.min(sourceColumns - 1, Math.floor((column + 0.5) * sourceColumns / columns));
        const centreIsLand = worldMask[centreRow]?.[centreColumn] === '1';
        const coverage = sampledCells ? landCells / sampledCells : 0;
        return coverage >= 0.2 || (centreIsLand && coverage >= 0.08);
      }

      const minimumMapRenderWidth = 160;
      let lastValidMapGeometry = null;
      let mapRenderFrame = null;
      let mapRenderRetryTimer = null;

      function visibleMapGeometry() {
        if (!map || !map.isConnected || map.classList.contains('is-showing-live')) return null;
        const rect = map.getBoundingClientRect();
        const width = Math.round(rect.width || map.clientWidth || 0);
        const style = window.getComputedStyle(map);
        if (
          width < minimumMapRenderWidth
          || !map.getClientRects().length
          || style.display === 'none'
          || style.visibility === 'hidden'
        ) return null;
        const columns = width < 600 ? 64 : 96;
        return {
          width,
          height: Math.round(width * 9 / 16),
          columns,
          rows: Math.round(columns * 9 / 16),
          gapRatio: 0.16
        };
      }

      function mapGeometry() {
        const geometry = visibleMapGeometry();
        if (geometry) lastValidMapGeometry = geometry;
        return geometry || lastValidMapGeometry;
      }

      function drawPixelMap() {
        if (!mapCanvas || !map) return false;
        const geometry = visibleMapGeometry();
        if (!geometry) return false;
        lastValidMapGeometry = geometry;
        const ratio = Math.max(1, window.devicePixelRatio || 1);
        const { width, height, columns, rows, gapRatio } = geometry;
        mapCanvas.width = Math.round(width * ratio);
        mapCanvas.height = Math.round(height * ratio);
        const context = mapCanvas.getContext('2d');
        if (!context) return false;
        context.scale(ratio, ratio);
        context.clearRect(0, 0, width, height);

        const cell = width / columns;
        const gap = Math.max(1, cell * gapRatio);
        context.fillStyle = 'rgba(58, 170, 53, 0.28)';

        for (let row = 0; row < rows; row += 1) {
          for (let column = 0; column < columns; column += 1) {
            if (!cellHasLand(column, row, columns, rows)) continue;
            context.fillRect(column * cell + gap / 2, row * cell + gap / 2, cell - gap, cell - gap);
          }
        }
        return true;
      }

      function mapRegion(city) {
        const value = String(city || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
        if (/(^| )(london|folkestone|kent|canterbury|dover|brighton|croydon|bromley|greenwich|lewisham|southwark|lambeth|hackney|camden|westminster)( |$)/.test(value)) {
          return 'uk-south-east';
        }
        if (/(^| )(birmingham|brum|coventry|wolverhampton|west midlands)( |$)/.test(value)) {
          return 'uk-midlands';
        }
        if (/(^| )(manchester|manny|salford|stockport|bolton|north west)( |$)/.test(value)) {
          return 'uk-north-west';
        }
        return '';
      }

      function calibratedPosition(latitude, longitude) {
        const left = 1 + ((Number(longitude) + 168) / 348) * 89;
        const top = 7 + ((83 - Number(latitude)) / 141) * 74;
        return {
          left: Math.max(1, Math.min(90, left)),
          top: Math.max(7, Math.min(81, top))
        };
      }

      function mapGrid() {
        return mapGeometry() || { columns: 96, rows: 54, gapRatio: 0.16 };
      }

      function snapPositionToLand(projected, excludedCells = new Set()) {
        const { columns, rows } = mapGrid();
        const targetColumn = Math.max(0, Math.min(columns - 1, Math.floor(projected.left * columns / 100)));
        const targetRow = Math.max(0, Math.min(rows - 1, Math.floor(projected.top * rows / 100)));
        let nearest = null;

        for (let radius = 0; radius <= Math.max(columns, rows) && !nearest; radius += 1) {
          for (let row = targetRow - radius; row <= targetRow + radius; row += 1) {
            for (let column = targetColumn - radius; column <= targetColumn + radius; column += 1) {
              if (column < 0 || column >= columns || row < 0 || row >= rows) continue;
              if (!cellHasLand(column, row, columns, rows)) continue;
              if (excludedCells.has(`${column}:${row}`)) continue;
              const distance = Math.hypot(column - targetColumn, row - targetRow);
              if (!nearest || distance < nearest.distance) nearest = { column, row, distance };
            }
          }
        }

        if (!nearest) return null;
        return {
          left: ((nearest.column + 0.5) / columns) * 100,
          top: ((nearest.row + 0.5) / rows) * 100,
          column: nearest.column,
          row: nearest.row
        };
      }

      function regionalPosition(region) {
        const anchors = {
          'uk-south-east': { left: 41.15, top: 21.3 },
          'uk-midlands': { left: 41.15, top: 19.45 },
          'uk-north-west': { left: 40.1, top: 19.45 }
        };
        return anchors[region] || null;
      }

      function coordinatesToPosition(latitude, longitude, city = '') {
        const region = mapRegion(city);
        const projected = regionalPosition(region) || calibratedPosition(latitude, longitude);
        return snapPositionToLand(projected);
      }

      function renderMapMarkers(profiles) {
        if (!mapMarkers) return false;
        const geometry = visibleMapGeometry();
        if (!geometry) return false;
        lastValidMapGeometry = geometry;
        mapMarkers.replaceChildren();
        const cityGroups = new Map();
        profiles
          .filter((profile) => (
            profile.friendship !== 'blocked'
            &&
            profile.latitude !== null
            && profile.latitude !== undefined
            && profile.latitude !== ''
            && profile.longitude !== null
            && profile.longitude !== undefined
            && profile.longitude !== ''
            && Number.isFinite(Number(profile.latitude))
            && Number.isFinite(Number(profile.longitude))
          ))
          .forEach((profile) => {
            const city = displayCity(profile.city || '');
            const key = normalizeCity(city);
            if (!key) return;
            if (!cityGroups.has(key)) cityGroups.set(key, []);
            cityGroups.get(key).push(profile);
          });

        const markerGroups = new Map();
        cityGroups.forEach((players, cityKey) => {
          const region = mapRegion(players[0].city);
          const position = coordinatesToPosition(players[0].latitude, players[0].longitude, players[0].city);
          if (!position) return;
          const collisionKey = region || `${Math.round(position.left / 1.6)}:${Math.round(position.top / 2.2)}`;
          const group = markerGroups.get(collisionKey) || { players: [], positions: [], region };
          group.players.push(...players);
          group.positions.push(position);
          markerGroups.set(collisionKey, group);
        });

        const occupiedCells = new Set();
        markerGroups.forEach((group, key) => {
          const players = group.players;
          const position = snapPositionToLand(group.positions[0], occupiedCells);
          if (!position) return;
          occupiedCells.add(`${position.column}:${position.row}`);
          const { columns, rows, gapRatio } = mapGrid();
          const marker = document.createElement('button');
          marker.type = 'button';
          marker.className = 'osb-finder__map-marker';
          marker.style.left = `${((position.column + gapRatio / 2) / columns) * 100}%`;
          marker.style.top = `${((position.row + gapRatio / 2) / rows) * 100}%`;
          marker.style.width = `${((1 - gapRatio) / columns) * 100}%`;
          marker.style.height = `${((1 - gapRatio) / rows) * 100}%`;
          const playerCount = `${players.length} ${players.length === 1 ? 'player' : 'players'}`;
          const cities = [...new Set(players.map((profile) => displayCity(profile.city)).filter(Boolean))];
          const areaLabel = cities[0] || 'this area';
          marker.setAttribute('aria-label', `show ${playerCount} in ${areaLabel}`);
          marker.title = `${areaLabel} · ${playerCount}`;
          marker.addEventListener('click', () => {
            selectDirectoryView('area', areaLabel, players);
          });
          marker.dataset.region = key;
          mapMarkers.appendChild(marker);
        });
        return true;
      }

      function scheduleStableMapRender(attempt = 0) {
        window.cancelAnimationFrame(mapRenderFrame);
        if (attempt === 0) window.clearTimeout(mapRenderRetryTimer);
        mapRenderFrame = window.requestAnimationFrame(() => {
          if (drawPixelMap()) {
            renderMapMarkers(directoryProfiles);
            return;
          }
          if (attempt < 6) {
            window.clearTimeout(mapRenderRetryTimer);
            mapRenderRetryTimer = window.setTimeout(
              () => scheduleStableMapRender(attempt + 1),
              80 * (attempt + 1)
            );
          }
        });
      }

      async function loadAccountDirectory() {
        if (!liveServerUrl || !hasSignedInAccount()) return [];
        try {
          const response = await fetch(`${liveServerUrl}/api/directory`, {
            headers: { authorization: `Bearer ${accountSession.token}` }
          });
          if (response.status === 401) {
            expireAccountSession();
            return [];
          }
          if (!response.ok) return [];
          const payload = await response.json();
          return Array.isArray(payload.players)
            ? payload.players
              .filter((player) => player.id !== accountSession?.player?.id)
              .filter((player) => player.legacy !== true)
              .map((player) => ({
                name: player.username || player.name || '',
                username: player.username || player.name || '',
                osbPlayerId: player.id || '',
                chess: player.chess || '',
                city: player.city || '',
                instagram: player.instagram || '',
                level: player.level || '',
                createdAt: player.createdAt || '',
                latitude: player.latitude,
                longitude: player.longitude,
                requestable: player.requestable !== false,
                legacy: player.legacy === true,
                active: player.active === true,
                playing: player.playing === true,
                friendship: player.friendship || 'none',
                friendRequestId: player.friendRequestId || ''
              }))
            : [];
        } catch (error) {
          return [];
        }
      }

      async function refreshDirectory() {
        if (!hasSignedInAccount()) {
          clearMemberDirectory();
          return;
        }
        if (directoryRefreshPending) return;
        directoryRefreshPending = true;
        const expandedPlayerId = matches
          ?.querySelector('button.osb-finder__name[aria-expanded="true"]')
          ?.closest('.osb-finder__player')
          ?.dataset.osbPlayerId || '';
        try {
          const nextDirectoryProfiles = await loadAccountDirectory();
          if (!hasSignedInAccount()) {
            clearMemberDirectory();
            return;
          }
          if (
            directoryProfilesSignature(directoryProfiles)
            === directoryProfilesSignature(nextDirectoryProfiles)
          ) return;
          directoryProfiles = nextDirectoryProfiles;
          renderMapMarkers(directoryProfiles);
          renderDirectoryMenu();
          if (
            selectedDirectoryMode
            && results
            && !results.hidden
          ) {
            showProfileCards(
              selectedDirectoryProfiles(),
              selectedDirectoryLabel || 'players',
              { animate: false, refreshMenu: false }
            );
            if (expandedPlayerId) {
              const expandedPlayer = [...matches.querySelectorAll('.osb-finder__player')]
                .find((player) => player.dataset.osbPlayerId === expandedPlayerId);
              const expandedControl = expandedPlayer?.querySelector('button.osb-finder__name');
              const expandedActions = expandedPlayer?.querySelector('[data-osb-player-actions]');
              if (expandedControl && expandedActions) {
                expandedControl.setAttribute('aria-expanded', 'true');
                expandedActions.hidden = false;
              }
            }
          }
        } finally {
          directoryRefreshPending = false;
        }
      }

      function updateReadiness() {
        const citySelected = Boolean(cityPlaceIdInput?.value)
          && cityInput?.value === cityInput?.dataset.selectedCity;
        const ready = requiredFields.length
          && requiredFields.every((field) => field.checkValidity())
          && citySelected;
        trigger?.classList.toggle('is-ready', ready);
      }

      function closeCityOptions() {
        citySearchController?.abort();
        citySearchController = null;
        cityOptions?.replaceChildren();
        if (cityOptions) cityOptions.hidden = true;
        cityInput?.setAttribute('aria-expanded', 'false');
      }

      function selectCity(city) {
        if (!cityInput || !cityPlaceIdInput) return;
        cityInput.value = displayCity(city?.name || city?.label);
        cityInput.dataset.selectedCity = cityInput.value;
        cityPlaceIdInput.value = String(city?.id || '');
        closeCityOptions();
        if (profileIntro) profileIntro.textContent = 'your one square better profile.';
        updateReadiness();
      }

      function renderCityOptions(cities) {
        if (!cityOptions) return;
        cityOptions.replaceChildren();
        const shownLabels = new Set();
        cities.forEach((city) => {
          const optionLabel = String(city.label || city.name || '').trim().toLowerCase();
          if (!optionLabel || shownLabels.has(optionLabel)) return;
          shownLabels.add(optionLabel);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'osb-finder__city-option';
          button.setAttribute('role', 'option');
          button.textContent = optionLabel;
          button.addEventListener('pointerdown', (event) => event.preventDefault());
          button.addEventListener('click', () => selectCity(city));
          cityOptions.appendChild(button);
        });
        cityOptions.hidden = !shownLabels.size;
        cityInput?.setAttribute('aria-expanded', shownLabels.size ? 'true' : 'false');
      }

      async function resolveExistingCitySelection(city) {
        const existingCity = displayCity(
          accountSession?.player?.city || loadSavedProfile()?.city || ''
        );
        if (!city || city !== existingCity || !accountSession?.token || !liveServerUrl) return false;
        try {
          const response = await fetch(`${liveServerUrl}/api/cities?q=${encodeURIComponent(city)}`, {
            headers: { authorization: `Bearer ${accountSession.token}` }
          });
          if (response.status === 401) {
            expireAccountSession();
            return false;
          }
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) return false;
          const exact = (Array.isArray(payload.cities) ? payload.cities : []).find((candidate) => (
            displayCity(candidate.name || candidate.label) === city
          ));
          if (!exact) return false;
          selectCity(exact);
          return true;
        } catch {
          return false;
        }
      }

      async function searchCityOptions() {
        const query = cityInput?.value.trim().toLowerCase() || '';
        if (!accountSession?.token || !liveServerUrl || query.length < 2) {
          closeCityOptions();
          return;
        }
        citySearchController?.abort();
        citySearchController = new AbortController();
        try {
          const response = await fetch(`${liveServerUrl}/api/cities?q=${encodeURIComponent(query)}`, {
            headers: { authorization: `Bearer ${accountSession.token}` },
            signal: citySearchController.signal
          });
          if (response.status === 401) return expireAccountSession();
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.error || 'city search is unavailable');
          renderCityOptions(Array.isArray(payload.cities) ? payload.cities : []);
        } catch (error) {
          if (error?.name !== 'AbortError') closeCityOptions();
        }
      }

      cityInput?.addEventListener('input', () => {
        cityInput.value = cityInput.value.toLowerCase();
        if (cityInput.value !== cityInput.dataset.selectedCity) {
          if (cityPlaceIdInput) cityPlaceIdInput.value = '';
          cityInput.dataset.selectedCity = '';
        }
        window.clearTimeout(citySearchTimer);
        citySearchTimer = window.setTimeout(searchCityOptions, 180);
        updateReadiness();
      });
      cityInput?.addEventListener('focus', () => {
        if (!cityPlaceIdInput?.value && cityInput.value.trim().length >= 2) searchCityOptions();
      });
      cityInput?.addEventListener('blur', () => window.setTimeout(closeCityOptions, 120));

      requiredFields.forEach((field) => {
        field.addEventListener('input', updateReadiness);
        field.addEventListener('change', updateReadiness);
      });

      function openMatcher(shouldFocus = true) {
        if (!panel || !trigger || panel.classList.contains('is-open')) return;
        hidePlayChoices();
        window.clearTimeout(matcherCloseTimer);
        recommendations?.classList.remove('is-visible');
        if (recommendations) recommendations.hidden = true;
        results?.classList.remove('is-visible');
        if (results) results.hidden = true;
        peopleButton?.setAttribute('aria-expanded', 'false');
        closeDirectorySelector();
        trigger.setAttribute('aria-expanded', 'true');
        trigger.classList.add('is-form-open');
        actions?.classList.add('is-form-open');
        panel.classList.add('is-laid-out');
        if (accountSession?.player?.kind === 'account') showProfileForm();
        else showSignin();
        requestAnimationFrame(() => {
          panel.classList.add('is-open');
          updateReadiness();
        });
        if (shouldFocus && accountSession?.player?.kind === 'account') {
          window.setTimeout(() => nameInput?.focus(), 120);
        }
      }

      function resetMatcherLayout({ immediate = false } = {}) {
        if (!panel || !trigger) return;
        panel.classList.remove('is-open', 'is-auth-mode');
        actions?.classList.remove('is-form-open', 'is-auth-open');
        trigger.classList.remove('is-form-open', 'is-auth-active');
        trigger.setAttribute('aria-expanded', 'false');
        window.clearTimeout(matcherCloseTimer);
        if (immediate) {
          panel.classList.remove('is-laid-out');
          return;
        }
        matcherCloseTimer = window.setTimeout(() => {
          if (!panel.classList.contains('is-open')) panel.classList.remove('is-laid-out');
        }, 820);
      }

      function closeMatcher() {
        if (!panel || !trigger || !panel.classList.contains('is-open')) return;
        resetMatcherLayout();
        updateRequestTrigger();
      }

      async function requestSuggestedPlayer(profile, button) {
        if (!accountSession?.token || !liveServerUrl || !profile?.osbPlayerId) return;
        const playerName = profile.name || profile.chess || 'player';
        const requestLabel = profile.playing ? 'next game' : 'request';
        markPending(button, 'sending');
        button.setAttribute('aria-label', `sending game request to ${playerName}`);
        try {
          const response = await fetch(`${liveServerUrl}/api/match-requests`, {
            method: 'POST',
            headers: {
              authorization: `Bearer ${accountSession.token}`,
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              recipientId: profile.osbPlayerId,
              kind: 'play'
            })
          });
          if (response.status === 401) {
            expireAccountSession();
            return;
          }
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.error || 'could not send request');
          requestedPlayerIds.add(profile.osbPlayerId);
          if (payload.request?.id) outgoingMatchRequests.set(profile.osbPlayerId, payload.request);
          markComplete(button, 'cancel', { confirmation: true });
          button.classList.add('is-positive');
          button.setAttribute('aria-label', `cancel game request to ${playerName}`);
          feedbackCue('success');
          loadMatchRequests();
        } catch (error) {
          markFailed(button, requestLabel);
          button.setAttribute(
            'aria-label',
            profile.playing
              ? `request the next game with ${playerName}, who is playing now`
              : `request a game with ${playerName}`
          );
          feedbackCue('error');
          if (accountStatus) accountStatus.textContent = error.message || 'could not send request';
        }
      }

      async function cancelSuggestedPlayer(profile, button) {
        if (!accountSession?.token || !profile?.osbPlayerId || !button) return;
        let request = outgoingMatchRequests.get(profile.osbPlayerId);
        if (!request?.id) {
          await loadMatchRequests();
          request = outgoingMatchRequests.get(profile.osbPlayerId);
        }
        if (!request?.id) {
          requestedPlayerIds.delete(profile.osbPlayerId);
          syncRequestedPlayerNames();
          return;
        }
        const playerName = profile.name || profile.chess || 'player';
        markPending(button, 'cancelling');
        try {
          const response = await fetch(`${liveServerUrl}/api/match-requests/${encodeURIComponent(request.id)}`, {
            method: 'PATCH',
            headers: {
              authorization: `Bearer ${accountSession.token}`,
              'content-type': 'application/json'
            },
            body: JSON.stringify({ action: 'cancel' })
          });
          if (response.status === 401) {
            expireAccountSession();
            return;
          }
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(payload.error || 'could not cancel request');
          requestedPlayerIds.delete(profile.osbPlayerId);
          outgoingMatchRequests.delete(profile.osbPlayerId);
          markComplete(button, profile.playing ? 'next game' : 'play');
          button.classList.remove('is-positive', 'is-requested');
          button.setAttribute(
            'aria-label',
            profile.playing
              ? `request the next game with ${playerName}, who is playing now`
              : `request a game with ${playerName}`
          );
          loadMatchRequests();
        } catch (error) {
          markFailed(button, 'cancel');
          feedbackCue('error');
          if (accountStatus) accountStatus.textContent = error.message || 'could not cancel request';
        }
      }

      function showPlayOptions() {
        showPlayChoices();
        closeDirectorySelector();
        results?.classList.remove('is-visible');
        if (results) results.hidden = true;
        playButton?.setAttribute('aria-expanded', 'true');
      }

      async function addFriend(profile, button) {
        if (!accountSession?.token || !profile?.osbPlayerId || !button) return;
        markPending(button, 'sending');
        try {
          const response = await fetch(`${liveServerUrl}/api/friends`, {
            method: 'POST',
            headers: {
              authorization: `Bearer ${accountSession.token}`,
              'content-type': 'application/json'
            },
            body: JSON.stringify({ recipientId: profile.osbPlayerId })
          });
          if (response.status === 401) {
            expireAccountSession();
            return;
          }
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(payload.error || 'could not add friend');
          profile.friendRequestId = payload.request?.id || '';
          profile.friendship = payload.request?.status === 'accepted'
            ? 'friend'
            : (payload.request?.recipientId === accountSession.player.id ? 'incoming' : 'outgoing');
          markComplete(button, profile.friendship === 'friend' ? 'friend' : 'requested', { confirmation: true });
          button.classList.add('is-positive');
          feedbackCue('success');
          await loadMatchRequests();
          await refreshDirectory();
        } catch (error) {
          markFailed(button, 'add friend');
          feedbackCue('error');
          if (accountStatus) accountStatus.textContent = error.message || 'could not add friend';
        }
      }

      async function acceptFriend(profile, button) {
        if (!accountSession?.token || !profile?.friendRequestId || !button) return;
        markPending(button, 'accepting');
        try {
          const response = await fetch(
            `${liveServerUrl}/api/friends/${encodeURIComponent(profile.friendRequestId)}`,
            {
              method: 'PATCH',
              headers: {
                authorization: `Bearer ${accountSession.token}`,
                'content-type': 'application/json'
              },
              body: JSON.stringify({ action: 'accept' })
            }
          );
          if (response.status === 401) {
            expireAccountSession();
            return;
          }
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(payload.error || 'could not accept friend');
          profile.friendship = 'friend';
          markComplete(button, 'friend', { confirmation: true });
          button.classList.add('is-positive');
          feedbackCue('success');
          await loadMatchRequests();
          await refreshDirectory();
        } catch (error) {
          markFailed(button, 'accept');
          feedbackCue('error');
          if (accountStatus) accountStatus.textContent = error.message || 'could not accept friend';
        }
      }

      async function updateFriendRequest(profile, action, button) {
        if (!accountSession?.token || !profile?.friendRequestId || !button) return;
        markPending(button, action === 'cancel' ? 'cancelling' : 'passing');
        try {
          const response = await fetch(
            `${liveServerUrl}/api/friends/${encodeURIComponent(profile.friendRequestId)}`,
            {
              method: 'PATCH',
              headers: {
                authorization: `Bearer ${accountSession.token}`,
                'content-type': 'application/json'
              },
              body: JSON.stringify({ action })
            }
          );
          const payload = await response.json().catch(() => ({}));
          if (response.status === 401) {
            expireAccountSession();
            return;
          }
          if (!response.ok) throw new Error(payload.error || 'try again');
          profile.friendship = 'none';
          profile.friendRequestId = '';
          markComplete(button, action === 'cancel' ? 'cancelled' : 'passed', { confirmation: true });
          feedbackCue('selection');
          Promise.all([loadMatchRequests(), refreshDirectory()]).catch(() => {});
        } catch (error) {
          markFailed(button, action);
          feedbackCue('error');
          if (accountStatus) accountStatus.textContent = error.message || 'try again';
        }
      }

      async function removeFriend(profile, button) {
        if (!accountSession?.token || !profile?.osbPlayerId || !button) return;
        markPending(button, 'removing');
        try {
          const response = await fetch(
            `${liveServerUrl}/api/friends/${encodeURIComponent(profile.osbPlayerId)}`,
            { method: 'DELETE', headers: { authorization: `Bearer ${accountSession.token}` } }
          );
          const payload = await response.json().catch(() => ({}));
          if (response.status === 401) {
            expireAccountSession();
            return;
          }
          if (!response.ok) throw new Error(payload.error || 'could not remove friend');
          profile.friendship = 'none';
          markComplete(button, 'removed', { confirmation: true });
          feedbackCue('selection');
          refreshDirectory().catch(() => {});
        } catch (error) {
          markFailed(button, 'remove friend');
          feedbackCue('error');
          if (accountStatus) accountStatus.textContent = error.message || 'try again';
        }
      }

      async function setPlayerBlocked(profile, blocked, button) {
        if (!accountSession?.token || !profile?.osbPlayerId || !button) return;
        markPending(button, blocked ? 'blocking' : 'unblocking');
        try {
          const response = await fetch(
            `${liveServerUrl}/api/friends/${encodeURIComponent(profile.osbPlayerId)}/block`,
            {
              method: blocked ? 'PUT' : 'DELETE',
              headers: { authorization: `Bearer ${accountSession.token}` }
            }
          );
          const payload = await response.json().catch(() => ({}));
          if (response.status === 401) {
            expireAccountSession();
            return;
          }
          if (!response.ok) throw new Error(payload.error || 'try again');
          profile.friendship = blocked ? 'blocked' : 'none';
          profile.friendRequestId = '';
          if (accountStatus) accountStatus.textContent = blocked ? 'player blocked.' : 'player unblocked.';
          feedbackCue('selection');
          await Promise.all([loadMatchRequests(), refreshDirectory()]);
        } catch (error) {
          markFailed(button, blocked ? 'block' : 'unblock');
          feedbackCue('error');
          if (accountStatus) accountStatus.textContent = error.message || 'try again';
        }
      }

      function createProfileElement(profile, { quiet = false, key = '' } = {}) {
        if (profile.element) {
          const clonedProfile = profile.element.cloneNode(true);
          clonedProfile.dataset.osbPlayerKey = key;
          clonedProfile.dataset.osbPlayerSignature = playerDirectorySignature(profile);
          clonedProfile.classList.toggle('is-quiet-refresh', quiet);
          return clonedProfile;
        }
        const article = document.createElement('article');
        article.className = 'osb-finder__player';
        article.dataset.osbPlayerId = profile.osbPlayerId || '';
        article.dataset.osbPlayerKey = key;
        article.dataset.osbPlayerSignature = playerDirectorySignature(profile);
        article.classList.toggle('is-quiet-refresh', quiet);

        const identity = document.createElement('span');
        identity.className = 'osb-finder__identity';

        if (profile.active) {
          const active = document.createElement('span');
          active.className = 'osb-finder__active';
          active.setAttribute('aria-label', profile.playing ? 'playing a game' : 'live now');
          active.title = profile.playing ? 'playing a game' : 'live now';
          identity.appendChild(active);
        }

        const canOpen = Boolean(
          profile.osbPlayerId
          && profile.osbPlayerId !== accountSession?.player?.id
        );
        const canRequest = canOpen
          && profile.requestable !== false
          && profile.friendship !== 'blocked';
        const nameGroup = document.createElement('span');
        nameGroup.className = 'osb-finder__name-group';
        const name = document.createElement(canOpen ? 'button' : 'span');
        if (canOpen) name.type = 'button';
        name.className = 'osb-finder__name';
        const playerName = profile.name || profile.chess || 'player';
        const requested = canRequest && requestedPlayerIds.has(profile.osbPlayerId);
        name.textContent = playerName;
        nameGroup.appendChild(name);
        identity.appendChild(nameGroup);

        if (profile.playing) {
          const playerState = document.createElement('span');
          playerState.className = 'osb-finder__player-state';
          playerState.textContent = 'playing game';
          nameGroup.appendChild(playerState);
        }

        const city = document.createElement('span');
        city.className = 'osb-finder__city';
        city.textContent = displayCity(profile.city) || 'city not set';

        const socials = document.createElement('span');
        socials.className = 'osb-finder__socials';

        const chess = document.createElement(profile.chess ? 'a' : 'span');
        if (profile.chess) {
          chess.className = 'osb-finder__handle';
          chess.href = `https://www.chess.com/member/${encodeURIComponent(profile.chess)}`;
          chess.target = '_blank';
          chess.rel = 'noopener noreferrer';
          chess.textContent = 'chess.com';
        } else {
          chess.className = 'osb-finder__handle osb-finder__handle--empty';
          chess.setAttribute('aria-hidden', 'true');
        }

        const instagram = document.createElement(profile.instagram ? 'a' : 'span');
        if (profile.instagram) {
          instagram.className = 'osb-finder__instagram';
          instagram.href = `https://www.instagram.com/${encodeURIComponent(profile.instagram)}/`;
          instagram.target = '_blank';
          instagram.rel = 'noopener noreferrer';
          instagram.textContent = 'instagram';
        } else {
          instagram.className = 'osb-finder__instagram osb-finder__instagram--empty';
          instagram.setAttribute('aria-hidden', 'true');
        }

        socials.append(chess, instagram);

        const playerActions = document.createElement('span');
        playerActions.className = 'osb-finder__player-actions';
        playerActions.dataset.osbPlayerActions = '';
        playerActions.hidden = true;
        if (canOpen) {
          if (canRequest) {
          const play = document.createElement('button');
          play.type = 'button';
          play.className = 'osb-finder__player-action';
          play.dataset.playerId = profile.osbPlayerId;
          play.dataset.playerName = playerName;
          play.dataset.playerPlaying = profile.playing ? 'true' : 'false';
          play.textContent = requested ? 'cancel' : (profile.playing ? 'next game' : 'play');
          play.disabled = false;
          play.classList.toggle('is-positive', requested);
          play.setAttribute('aria-label', requested
            ? `cancel game request to ${playerName}`
            : (profile.playing
              ? `request the next game with ${playerName}, who is playing now`
              : `request a game with ${playerName}`));
          play.addEventListener('click', () => (
            requestedPlayerIds.has(profile.osbPlayerId)
              ? cancelSuggestedPlayer(profile, play)
              : requestSuggestedPlayer(profile, play)
          ));
          playerActions.appendChild(play);
          }

          if (profile.legacy !== true) {
            const friend = document.createElement('button');
            friend.type = 'button';
            friend.className = 'osb-finder__player-action';
            if (profile.friendship === 'friend') {
              friend.textContent = 'remove friend';
              friend.addEventListener('click', () => removeFriend(profile, friend));
            } else if (profile.friendship === 'outgoing') {
              friend.textContent = 'cancel request';
              friend.addEventListener('click', () => updateFriendRequest(profile, 'cancel', friend));
            } else if (profile.friendship === 'incoming') {
              friend.textContent = 'accept';
              friend.addEventListener('click', () => acceptFriend(profile, friend));
            } else if (profile.friendship === 'blocked') {
              friend.textContent = 'unblock';
              friend.addEventListener('click', () => setPlayerBlocked(profile, false, friend));
            } else {
              friend.textContent = 'add friend';
              friend.addEventListener('click', () => addFriend(profile, friend));
            }
            friend.setAttribute('aria-label', `${friend.textContent} ${playerName}`);
            playerActions.appendChild(friend);

            if (profile.friendship === 'incoming') {
              const pass = document.createElement('button');
              pass.type = 'button';
              pass.className = 'osb-finder__player-action';
              pass.textContent = 'pass';
              pass.setAttribute('aria-label', `pass friend request from ${playerName}`);
              pass.addEventListener('click', () => updateFriendRequest(profile, 'pass', pass));
              playerActions.appendChild(pass);
            }
          }
          const actionId = `osb-player-actions-${String(profile.osbPlayerId).replace(/[^a-z0-9_-]/gi, '-')}`;
          playerActions.id = actionId;
          name.setAttribute('aria-controls', actionId);
          name.setAttribute('aria-expanded', 'false');
          name.setAttribute('aria-label', `show actions for ${playerName}`);
          name.addEventListener('click', () => {
            const opening = playerActions.hidden;
            matches?.querySelectorAll('[data-osb-player-actions]').forEach((actionsPanel) => {
              if (actionsPanel === playerActions) return;
              actionsPanel.hidden = true;
              const control = actionsPanel.closest('.osb-finder__player')?.querySelector('button.osb-finder__name');
              control?.setAttribute('aria-expanded', 'false');
            });
            playerActions.hidden = !opening;
            name.setAttribute('aria-expanded', String(opening));
          });
          nameGroup.appendChild(playerActions);
        }
        article.append(identity, city, socials);
        return article;
      }

      function showProfileCards(
        profiles,
        city,
        { animate = true, refreshMenu = true } = {}
      ) {
        if (!results || !status || !matches) return;
        closeCityOptions();
        if (panel?.classList.contains('is-open')) resetMatcherLayout({ immediate: true });
        recommendations?.classList.remove('is-visible');
        if (recommendations) recommendations.hidden = true;
        const createdTime = (profile) => {
          const parsed = Date.parse(profile?.createdAt || '');
          return Number.isFinite(parsed) ? parsed : Number.POSITIVE_INFINITY;
        };
        const orderedProfiles = profiles
          .map((profile, index) => ({ profile, index }))
          .sort((left, right) => (
            Number(right.profile.active && !right.profile.playing)
              - Number(left.profile.active && !left.profile.playing)
            || Number(right.profile.playing) - Number(left.profile.playing)
            || createdTime(left.profile) - createdTime(right.profile)
            || left.index - right.index
          ))
          .map(({ profile }) => profile);
        const cleanCity = String(city || '').trim();
        if (directorySelector) directorySelector.hidden = false;
        if (playerSearchWrap) playerSearchWrap.hidden = selectedDirectoryMode !== 'find';
        if (directoryLabel) {
          const showArea = selectedDirectoryMode === 'area';
          directoryLabel.hidden = !showArea;
          directoryLabel.textContent = showArea ? cleanCity.toLowerCase() : '';
        }
        const emptyMessages = {
          all: 'no players yet.',
          friends: 'no friends yet.',
          find: playerSearchQuery.trim().length < 2
            ? 'type a username.'
            : 'no players found.'
        };
        const emptyMessage = orderedProfiles.length
          ? ''
          : (emptyMessages[selectedDirectoryMode] || 'no players here yet.');
        status.textContent = emptyMessage;
        status.hidden = !emptyMessage;
        const existingProfiles = new Map(
          [...matches.children].map((player) => [
            player.dataset.osbPlayerKey || '',
            player
          ])
        );
        const desiredPlayers = orderedProfiles.map((profile, index) => {
          const key = playerDirectoryKey(profile, index);
          const signature = playerDirectorySignature(profile);
          const existingPlayer = existingProfiles.get(key);
          if (existingPlayer?.dataset.osbPlayerSignature === signature) {
            return existingPlayer;
          }
          const wasExpanded = existingPlayer
            ?.querySelector('button.osb-finder__name')
            ?.getAttribute('aria-expanded') === 'true';
          const player = createProfileElement(profile, {
            quiet: !animate,
            key
          });
          if (wasExpanded) {
            const playerControl = player.querySelector('button.osb-finder__name');
            const playerActions = player.querySelector('[data-osb-player-actions]');
            if (playerControl && playerActions) {
              playerControl.setAttribute('aria-expanded', 'true');
              playerActions.hidden = false;
            }
          }
          return player;
        });
        desiredPlayers.forEach((player, index) => {
          const currentPlayer = matches.children[index];
          if (currentPlayer !== player) {
            matches.insertBefore(player, currentPlayer || null);
          }
        });
        const desiredPlayerSet = new Set(desiredPlayers);
        [...matches.children].forEach((player) => {
          if (!desiredPlayerSet.has(player)) player.remove();
        });
        if (refreshMenu) renderDirectoryMenu();
        results.hidden = false;
        peopleButton?.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => {
          results.classList.add('is-visible');
          updateRequestTrigger();
        });
      }

      function showMatches(found, city) {
        selectedDirectoryMode = '';
        selectedDirectoryPlayerIds.clear();
        selectedDirectoryLabel = '';
        showProfileCards(found.map(({ profile }) => profile), found.length ? 'your game.' : city);
        if (!found.length && status) status.textContent = `no match in ${city.trim()} yet.`;
      }

      async function updateAccountProfile(profile) {
        if (!accountSession?.token) return;
        const response = await fetch(`${liveServerUrl}/api/profile`, {
          method: 'POST',
          headers: {
            authorization: `Bearer ${accountSession.token}`,
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            username: profile.username,
            cityPlaceId: profile.cityPlaceId,
            instagram: profile.instagram,
            chess: profile.chess
          })
        });
        if (response.status === 401) {
          expireAccountSession();
          throw new Error('session expired. sign in again.');
        }
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.error || 'could not save your profile');
        rememberAccount(payload);
      }

      function requestTime(request) {
        return Date.parse(
          request.respondedAt || request.updatedAt || request.updated || request.createdAt || request.created || ''
        ) || 0;
      }

      function requestPeerId(request) {
        if (!request || !accountSession?.player?.id) return '';
        return request.requesterId === accountSession.player.id
          ? (request.recipientId || request.recipientName || request.id)
          : (request.requesterId || request.requesterName || request.id);
      }

      function newestRequestPerPeer(requests) {
        const newest = new Map();
        requests
          .slice()
          .sort((first, second) => requestTime(second) - requestTime(first))
          .forEach((request) => {
            const key = requestPeerId(request);
            if (key && !newest.has(key)) newest.set(key, request);
          });
        return Array.from(newest.values());
      }

      function actionableRequestCount() {
        return requestInbox.incoming.length + requestInbox.friendIncoming.length;
      }

      function accountUsername() {
        const savedProfile = loadSavedProfile() || {};
        return accountSession?.player?.username
          || savedProfile.username
          || savedProfile.name
          || nameInput?.value
          || 'profile';
      }

      function applyNameLengthClass(element, value) {
        if (!element) return;
        const length = Array.from(String(value || '').trim()).length;
        element.classList.toggle('is-long-name', length > 12);
        element.classList.toggle('is-very-long-name', length > 18);
      }

      function playerDirectoryKey(profile, index = 0) {
        return String(
          profile?.osbPlayerId
          || profile?.id
          || `${profile?.name || 'player'}-${profile?.city || 'unknown'}-${index}`
        );
      }

      function playerDirectorySignature(profile) {
        const playerId = String(profile?.osbPlayerId || profile?.id || '');
        return JSON.stringify([
          playerId,
          String(profile?.name || ''),
          String(profile?.chess || ''),
          displayCity(profile?.city || ''),
          String(profile?.instagram || ''),
          String(profile?.level || ''),
          String(profile?.createdAt || ''),
          Number(profile?.lat || 0),
          Number(profile?.lon || 0),
          profile?.requestable !== false,
          profile?.active === true,
          profile?.playing === true,
          String(profile?.friendship || 'none'),
          String(profile?.friendRequestId || ''),
          requestedPlayerIds.has(playerId)
        ]);
      }

      function directoryProfilesSignature(profiles) {
        return [...(profiles || [])]
          .map((profile, index) => [
            playerDirectoryKey(profile, index),
            playerDirectorySignature(profile)
          ])
          .sort(([left], [right]) => left.localeCompare(right))
          .map(([key, signature]) => `${key}:${signature}`)
          .join('|');
      }

      function hidePlayChoices() {
        if (playChoices) playChoices.hidden = true;
        if (trigger) trigger.hidden = false;
      }

      function showPlayChoices() {
        if (!playChoices || !trigger) return;
        trigger.hidden = true;
        playChoices.hidden = false;
      }

      function updateRequestTrigger() {
        if (!trigger) return;
        const signedIn = accountSession?.player?.kind === 'account';
        const count = actionableRequestCount();
        actions?.classList.toggle('is-guest', !signedIn);
        if (signinTrigger) signinTrigger.hidden = signedIn;
        if (peopleButton) peopleButton.hidden = !signedIn;
        if (requestTriggerButton) {
          requestTriggerButton.hidden = !signedIn || !count;
          requestTriggerButton.textContent = count
            ? `${count} request${count === 1 ? '' : 's'}`
            : '';
          requestTriggerButton.setAttribute('aria-label', count
            ? `open ${count} request${count === 1 ? '' : 's'}`
            : 'open requests');
          requestTriggerButton.setAttribute(
            'aria-expanded',
            requestDialog?.classList.contains('is-visible') ? 'true' : 'false'
          );
        }
        if (playButton) {
          playButton.hidden = signedIn;
          playButton.textContent = 'guest';
          playButton.setAttribute('aria-label', 'play as guest');
        }
        if (identityLabel) {
          identityLabel.hidden = !signedIn;
          const username = signedIn ? accountUsername() : '';
          identityLabel.textContent = username;
          applyNameLengthClass(identityLabel, username);
        }
        if (panel?.classList.contains('is-open') || (requestDialog && !requestDialog.hidden) || livePreviewShown) return;
        if (signedIn && profileSaved) {
          showPlayChoices();
          return;
        }
        hidePlayChoices();
        trigger.textContent = 'join';
      }

      function requestResponseErrorMessage(message) {
        const normalized = String(message || '').toLowerCase();
        return /(expired|not found|already|answered|pending)/.test(normalized)
          ? 'request expired or already answered.'
          : 'could not respond. try again.';
      }

      function positionRequestInbox() {
        if (!requestDialog || requestDialog.hidden) return;
        window.cancelAnimationFrame(requestPositionFrame);
        requestPositionFrame = window.requestAnimationFrame(() => {
          requestDialog.classList.remove('is-above');
          const stack = requestDialog.closest('.osb-finder__request-stack, .osb-finder__actions');
          if (!stack) return;
          const rect = stack.getBoundingClientRect();
          const desiredHeight = Math.min(requestDialog.scrollHeight, window.innerHeight * 0.5);
          const roomBelow = window.innerHeight - rect.bottom - 12;
          const roomAbove = rect.top - 12;
          requestDialog.classList.toggle('is-above', roomBelow < desiredHeight && roomAbove > roomBelow);
        });
      }

      function closeRequestInbox(clearNotice = true) {
        window.clearTimeout(requestCloseTimer);
        if (clearNotice) requestInboxNotice = '';
        requestDialog?.classList.remove('is-visible');
        requestDialog?.classList.remove('is-above');
        requestTriggerButton?.setAttribute('aria-expanded', 'false');
        const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 260;
        requestCloseTimer = window.setTimeout(() => {
          if (requestDialog && !requestDialog.classList.contains('is-visible')) requestDialog.hidden = true;
          actions?.classList.remove('is-request-open');
          updateRequestTrigger();
        }, delay);
      }

      function openRequestInbox() {
        if (!requestDialog || (!actionableRequestCount() && !requestInboxNotice)) return;
        renderRequestInbox();
        window.clearTimeout(requestCloseTimer);
        requestDialog.hidden = false;
        actions?.classList.add('is-request-open');
        requestTriggerButton?.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(() => {
          requestDialog.classList.add('is-visible');
          positionRequestInbox();
        });
      }

      function renderRequestInbox() {
        if (!accountRequests) return;
        accountRequests.replaceChildren();
        const count = actionableRequestCount();
        if (requestTitle) {
          requestTitle.textContent = count
            ? `${count} request${count === 1 ? '' : 's'}`
            : 'request';
        }

        if (requestInboxNotice) {
          const notice = document.createElement('p');
          notice.className = 'osb-finder__request-line osb-finder__request-notice';
          notice.textContent = requestInboxNotice;
          accountRequests.appendChild(notice);
        }

        requestInbox.incoming.forEach((request) => {
          const line = document.createElement('div');
          line.className = 'osb-finder__request-line';
          const name = document.createElement('span');
          name.className = 'osb-finder__requester';
          name.textContent = request.requesterName || 'player';
          const responses = document.createElement('span');
          responses.className = 'osb-finder__request-responses';
          ['accept', 'pass'].forEach((action) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'osb-finder__request-response';
            button.textContent = action;
            button.addEventListener('click', () => respondToMatchRequest(request, action, line));
            responses.appendChild(button);
          });
          line.append(name, responses);
          accountRequests.appendChild(line);
        });

        requestInbox.friendIncoming.forEach((request) => {
          const line = document.createElement('div');
          line.className = 'osb-finder__request-line';
          const name = document.createElement('span');
          name.className = 'osb-finder__requester';
          name.textContent = `${request.requesterName || 'player'} · friend`;
          const responses = document.createElement('span');
          responses.className = 'osb-finder__request-responses';
          ['accept', 'pass'].forEach((action) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'osb-finder__request-response';
            button.textContent = action;
            button.addEventListener('click', () => respondToFriendRequest(request, action, line));
            responses.appendChild(button);
          });
          line.append(name, responses);
          accountRequests.appendChild(line);
        });

        if (!count && !requestInboxNotice) closeRequestInbox(false);
        else positionRequestInbox();
      }

      function syncRequestedPlayerNames() {
        matches?.querySelectorAll('button.osb-finder__player-action[data-player-id]').forEach((button) => {
          const requested = requestedPlayerIds.has(button.dataset.playerId || '');
          const playerName = button.dataset.playerName || 'player';
          button.disabled = false;
          button.classList.toggle('is-requested', requested);
          button.classList.toggle('is-positive', requested);
          button.textContent = requested
            ? 'cancel'
            : (button.dataset.playerPlaying === 'true' ? 'next game' : 'play');
          button.setAttribute('aria-label', requested
            ? `cancel game request to ${playerName}`
            : (button.dataset.playerPlaying === 'true'
              ? `request the next game with ${playerName}, who is playing now`
              : `request a game with ${playerName}`));
        });
      }

      async function loadMatchRequests() {
        if (!accountRequests || !accountSession?.token || !liveServerUrl) return;
        try {
          const headers = { authorization: `Bearer ${accountSession.token}` };
          const [response, friendResponse] = await Promise.all([
            fetch(`${liveServerUrl}/api/match-requests`, { headers }),
            fetch(`${liveServerUrl}/api/friends`, { headers })
          ]);
          if (response.status === 401 || friendResponse.status === 401) {
            expireAccountSession();
            return;
          }
          if (!response.ok || !friendResponse.ok) return;
          const payload = await response.json();
          const friendPayload = await friendResponse.json();
          const requests = Array.isArray(payload.requests) ? payload.requests : [];
          const friendRequests = Array.isArray(friendPayload.requests) ? friendPayload.requests : [];
          const oldestActionableTime = Date.now() - (30 * 60_000);
          const incoming = newestRequestPerPeer(requests.filter((request) => (
            request.kind === 'play'
            && request.recipientId === accountSession.player.id
            && request.status === 'pending'
            && requestTime(request) >= oldestActionableTime
          )));
          const outgoing = newestRequestPerPeer(requests.filter((request) => (
            request.kind === 'play'
            && request.requesterId === accountSession.player.id
            && request.status === 'pending'
            && requestTime(request) >= oldestActionableTime
          )));
          outgoingMatchRequests = new Map(
            outgoing
              .filter((request) => request.recipientId && request.id)
              .map((request) => [request.recipientId, request])
          );
          requestedPlayerIds = new Set(outgoingMatchRequests.keys());
          const friendIncoming = newestRequestPerPeer(friendRequests.filter((request) => (
            request.kind === 'friend'
            && request.recipientId === accountSession.player.id
            && request.status === 'pending'
          )));
          syncRequestedPlayerNames();
          requestInbox = { incoming, friendIncoming };
          incoming.forEach(notifyIncomingRequest);
          friendIncoming.forEach(notifyIncomingRequest);
          if (requestDialog && !requestDialog.hidden) renderRequestInbox();
          updateRequestTrigger();
        } catch (error) {}
      }

      async function respondToFriendRequest(request, action, line) {
        if (!accountSession?.token) return;
        const buttons = line?.querySelectorAll?.('button') || [];
        buttons.forEach((button) => {
          markPending(button, button.textContent);
        });
        try {
          const response = await fetch(`${liveServerUrl}/api/friends/${encodeURIComponent(request.id)}`, {
            method: 'PATCH',
            headers: {
              authorization: `Bearer ${accountSession.token}`,
              'content-type': 'application/json'
            },
            body: JSON.stringify({ action })
          });
          if (response.status === 401) {
            expireAccountSession();
            return;
          }
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(payload.error || 'try again');
          line.textContent = action === 'accept' ? 'friend added.' : 'passed.';
          line.classList.add('is-confirmation');
          feedbackCue(action === 'accept' ? 'success' : 'selection');
          await loadMatchRequests();
          await refreshDirectory();
        } catch (error) {
          buttons.forEach((button) => {
            markFailed(button, button.textContent);
          });
          line.textContent = 'could not respond. try again.';
          feedbackCue('error');
        }
      }

      async function respondToMatchRequest(request, action, line) {
        if (!accountSession?.token) return;
        requestInboxNotice = '';
        const buttons = line?.querySelectorAll?.('button') || [];
        buttons.forEach((button) => {
          markPending(button, button.textContent);
        });
        try {
          const response = await fetch(`${liveServerUrl}/api/match-requests/${encodeURIComponent(request.id)}`, {
            method: 'PATCH',
            headers: {
              authorization: `Bearer ${accountSession.token}`,
              'content-type': 'application/json'
            },
            body: JSON.stringify({ action })
          });
          if (response.status === 401) {
            expireAccountSession();
            return;
          }
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.error || 'try again');
          line.textContent = action === 'accept' ? 'accepted.' : 'passed.';
          line.classList.add('is-confirmation');
          feedbackCue(action === 'accept' ? 'success' : 'selection');
          if (action === 'accept' && payload.request) {
            window.setTimeout(() => {
              closeRequestInbox();
              showLivePreview('account');
            }, 420);
          }
          window.setTimeout(loadMatchRequests, action === 'accept' ? 460 : 680);
        } catch (error) {
          buttons.forEach((button) => {
            markFailed(button, button.textContent);
          });
          const message = requestResponseErrorMessage(error?.message);
          requestInboxNotice = message;
          line?.replaceChildren();
          if (line) {
            line.textContent = message;
            line.classList.remove('is-confirmation');
            line.classList.add('osb-finder__request-notice');
          }
          positionRequestInbox();
          feedbackCue('error');
        }
      }

      function takeMatchResponseQuery() {
        if (matchResponseQueryHandled) return null;
        const current = new URL(window.location.href);
        if (!current.searchParams.has('request') && !current.searchParams.has('response')) return null;
        matchResponseQueryHandled = true;
        const responseQuery = {
          requestId: current.searchParams.get('request') || '',
          action: current.searchParams.get('response') || ''
        };
        current.searchParams.delete('request');
        current.searchParams.delete('response');
        window.history.replaceState({}, '', current.href);
        return responseQuery;
      }

      async function applyMatchResponseQuery() {
        if (!accountSession?.token || !accountRequests || matchResponseQueryHandled) return;
        const responseQuery = takeMatchResponseQuery();
        if (!responseQuery) return;
        const { requestId, action } = responseQuery;
        if (!/^[0-9a-f-]{36}$/i.test(requestId) || !['accept', 'pass'].includes(action)) {
          requestInboxNotice = 'request expired or already answered.';
          await loadMatchRequests();
          openRequestInbox();
          return;
        }
        requestInboxNotice = '';
        if (requestDialog) requestDialog.hidden = false;
        actions?.classList.add('is-request-open');
        requestTriggerButton?.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(() => {
          requestDialog?.classList.add('is-visible');
          positionRequestInbox();
        });
        if (requestTitle) requestTitle.textContent = 'request';
        accountRequests.replaceChildren();
        const line = document.createElement('p');
        line.className = 'osb-finder__request-line';
        line.textContent = 'responding…';
        accountRequests.prepend(line);
        await respondToMatchRequest({ id: requestId }, action, line);
      }

      function signOut() {
        disconnectPresence();
        presencePaused = false;
        window.localStorage.removeItem(accountStorageKey);
        window.google?.accounts?.id?.disableAutoSelect?.();
        accountSession = null;
        profileSaved = false;
        requestInbox = { incoming: [], friendIncoming: [] };
        requestInboxNotice = '';
        matchResponseQueryHandled = false;
        requestedPlayerIds.clear();
        outgoingMatchRequests.clear();
        closeRequestInbox();
        hidePlayChoices();
        if (requestTriggerButton) requestTriggerButton.hidden = true;
        clearMemberDirectory();
        hideLivePreview();
        form?.reset();
        if (form) form.hidden = false;
        if (profileSignin) profileSignin.hidden = true;
        if (accountTools) accountTools.hidden = true;
        accountRequests?.replaceChildren();
        if (accountStatus) accountStatus.textContent = '';
        panel?.classList.remove('is-open');
        panel?.classList.remove('is-laid-out');
        panel?.classList.remove('is-auth-mode');
        actions?.classList.remove('is-form-open', 'is-auth-open');
        trigger?.classList.remove('is-form-open', 'is-ready', 'is-auth-active');
        trigger?.setAttribute('aria-expanded', 'false');
        if (trigger) trigger.textContent = 'join';
        actions?.classList.add('is-guest');
        if (signinTrigger) signinTrigger.hidden = false;
        if (playButton) {
          playButton.hidden = false;
          playButton.textContent = 'guest';
          playButton.setAttribute('aria-label', 'play as guest');
        }
        if (identityLabel) {
          identityLabel.hidden = true;
          identityLabel.textContent = '';
        }
        recommendations?.classList.remove('is-visible');
        if (recommendations) recommendations.hidden = true;
        results?.classList.remove('is-visible');
        if (results) results.hidden = true;
        document.dispatchEvent(new CustomEvent('osb:account-session-cleared'));
      }

      function expireAccountSession() {
        signOut();
        openMatcher(false);
        if (profileSigninStatus) profileSigninStatus.textContent = 'session expired. sign in again.';
      }

      document.addEventListener('osb:account-session-expired', expireAccountSession);

      function editProfile() {
        showProfileForm();
        nameInput?.focus();
      }

      async function setDirectoryVisibility() {
        if (!accountSession?.token || !visibilityButton) return;
        const visible = accountSession.player.directoryVisible === false;
        markPending(visibilityButton, visible ? 'showing' : 'hiding');
        try {
          const response = await fetch(`${liveServerUrl}/api/profile/visibility`, {
            method: 'POST',
            headers: {
              authorization: `Bearer ${accountSession.token}`,
              'content-type': 'application/json'
            },
            body: JSON.stringify({ visible })
          });
          const payload = await response.json();
          if (response.status === 401) return expireAccountSession();
          if (!response.ok) throw new Error(payload.error || 'could not update the map');
          rememberAccount(payload);
          await refreshDirectory();
          markComplete(visibilityButton, visible ? 'hide from map' : 'show on map', { confirmation: true });
          feedbackCue('success');
          if (accountStatus) accountStatus.textContent = visible ? 'shown on the map.' : 'hidden from the map.';
        } catch (error) {
          markFailed(visibilityButton, visible ? 'show on map' : 'hide from map');
          feedbackCue('error');
          if (accountStatus) accountStatus.textContent = error.message || 'try again.';
        }
      }

      async function setEmailMatchRequests() {
        if (!accountSession?.token || !emailMatchRequestsButton) return;
        const enabled = accountSession.player.emailMatchRequests !== true;
        markPending(emailMatchRequestsButton, 'saving');
        try {
          const response = await fetch(`${liveServerUrl}/api/profile/email-match-requests`, {
            method: 'POST',
            headers: {
              authorization: `Bearer ${accountSession.token}`,
              'content-type': 'application/json'
            },
            body: JSON.stringify({ enabled })
          });
          const payload = await response.json();
          if (response.status === 401) return expireAccountSession();
          if (!response.ok) throw new Error(payload.error || 'could not save email preference');
          rememberAccount(payload);
          markComplete(
            emailMatchRequestsButton,
            enabled ? 'email match requests on' : 'email match requests off',
            { confirmation: true }
          );
          feedbackCue('success');
          if (accountStatus) {
            accountStatus.textContent = enabled
              ? 'match request emails on.'
              : 'match request emails off.';
          }
        } catch (error) {
          markFailed(
            emailMatchRequestsButton,
            enabled ? 'email match requests off' : 'email match requests on'
          );
          feedbackCue('error');
          if (accountStatus) accountStatus.textContent = error.message || 'try again.';
        }
      }

      function resetDeleteConfirmation() {
        window.clearTimeout(deleteConfirmationTimer);
        deleteProfileButton?.classList.remove('is-confirming');
        if (deleteProfileButton) deleteProfileButton.textContent = 'delete profile';
      }

      async function deleteProfile() {
        if (!accountSession?.token || !deleteProfileButton) return;
        if (!deleteProfileButton.classList.contains('is-confirming')) {
          deleteProfileButton.classList.add('is-confirming');
          deleteProfileButton.textContent = 'delete profile?';
          if (accountStatus) accountStatus.textContent = 'press again to permanently delete.';
          deleteConfirmationTimer = window.setTimeout(resetDeleteConfirmation, 6000);
          return;
        }
        const playerId = accountSession.player.id;
        deleteProfileButton.disabled = true;
        try {
          const response = await fetch(`${liveServerUrl}/api/profile`, {
            method: 'DELETE',
            headers: { authorization: `Bearer ${accountSession.token}` }
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.error || 'could not delete your profile');
          const key = profileStorageKey(playerId);
          if (key) window.localStorage.removeItem(key);
          signOut();
          await refreshDirectory();
        } catch (error) {
          if (accountStatus) accountStatus.textContent = error.message || 'try again.';
          deleteProfileButton.disabled = false;
          resetDeleteConfirmation();
        }
      }

      function updateAdminSheetStatus(sheets) {
        if (!adminStatus) return;
        if (!sheets?.configured) adminStatus.textContent = 'sheet not connected.';
        else if (sheets.lastError) adminStatus.textContent = sheets.lastError;
        else if (sheets.lastSyncedAt) adminStatus.textContent = `sheet synced ${new Date(sheets.lastSyncedAt).toLocaleString()}.`;
        else adminStatus.textContent = 'sheet ready.';
      }

      function adminActionButton(label, action, playerId) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.addEventListener('click', () => runAdminAction(playerId, action, button));
        return button;
      }

      function renderAdminPlayers(players) {
        if (!adminPlayers) return;
        adminPlayers.replaceChildren();
        (players || []).forEach((player) => {
          const row = document.createElement('div');
          row.className = 'osb-finder__admin-player';
          const identity = document.createElement('span');
          identity.textContent = player.username || 'profile incomplete';
          const place = document.createElement('span');
          place.textContent = displayCity(player.city) || 'no city';
          const meta = document.createElement('span');
          meta.className = 'osb-finder__admin-player-meta';
          meta.textContent = player.accountStatus === 'suspended'
            ? 'suspended'
            : player.directoryVisible ? 'on map' : 'off map';
          const controls = document.createElement('div');
          controls.className = 'osb-finder__admin-actions';
          if (player.id === accountSession?.player?.id) {
            const current = document.createElement('span');
            current.textContent = 'you';
            controls.appendChild(current);
          } else {
            controls.appendChild(adminActionButton(player.directoryVisible ? 'hide' : 'show', player.directoryVisible ? 'hide' : 'show', player.id));
            controls.appendChild(adminActionButton(player.accountStatus === 'suspended' ? 'restore' : 'suspend', player.accountStatus === 'suspended' ? 'restore' : 'suspend', player.id));
            controls.appendChild(adminActionButton('delete', 'delete', player.id));
          }
          row.title = player.email || '';
          row.append(identity, place, meta, controls);
          adminPlayers.appendChild(row);
        });
      }

      async function loadAdminPlayers() {
        if (!accountSession?.token || accountSession.player.admin !== true) return;
        if (adminStatus) adminStatus.textContent = 'loading…';
        try {
          const response = await fetch(`${liveServerUrl}/api/admin/players`, {
            headers: { authorization: `Bearer ${accountSession.token}` }
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.error || 'could not load players');
          renderAdminPlayers(payload.players);
          updateAdminSheetStatus(payload.sheets);
        } catch (error) {
          if (adminStatus) adminStatus.textContent = error.message || 'try again.';
        }
      }

      async function runAdminAction(playerId, action, button) {
        if (!accountSession?.token) return;
        if (action === 'delete' && !button.classList.contains('is-confirming')) {
          button.classList.add('is-confirming');
          button.textContent = 'delete?';
          window.setTimeout(() => {
            button.classList.remove('is-confirming');
            button.textContent = 'delete';
          }, 6000);
          return;
        }
        button.disabled = true;
        try {
          const response = await fetch(`${liveServerUrl}/api/admin/players/${encodeURIComponent(playerId)}`, {
            method: action === 'delete' ? 'DELETE' : 'PATCH',
            headers: {
              authorization: `Bearer ${accountSession.token}`,
              'content-type': 'application/json'
            },
            body: action === 'delete' ? undefined : JSON.stringify({ action })
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.error || 'could not update the player');
          renderAdminPlayers(payload.players);
          updateAdminSheetStatus(payload.sheets);
          await refreshDirectory();
        } catch (error) {
          if (adminStatus) adminStatus.textContent = error.message || 'try again.';
          button.disabled = false;
        }
      }

      async function syncAdminSheet() {
        if (!accountSession?.token || !adminSyncButton) return;
        adminSyncButton.disabled = true;
        if (adminStatus) adminStatus.textContent = 'syncing…';
        try {
          const response = await fetch(`${liveServerUrl}/api/admin/sheets/sync`, {
            method: 'POST',
            headers: { authorization: `Bearer ${accountSession.token}` }
          });
          const payload = await response.json();
          updateAdminSheetStatus(payload.sheets);
          if (!response.ok) throw new Error(payload.sheets?.lastError || 'sheet sync failed');
        } catch (error) {
          if (adminStatus) adminStatus.textContent = error.message || 'try again.';
        } finally {
          adminSyncButton.disabled = false;
        }
      }

      function migrationSummary(migration) {
        const joins = migration?.community || {};
        const directory = migration?.directory || {};
        return `${joins.uniqueValid || 0} joins (${joins.duplicates || 0} duplicates), ${directory.uniqueValid || 0} directory profiles`;
      }

      async function migrateExistingSheet() {
        if (!accountSession?.token || !adminMigrateButton) return;
        const apply = adminMigrateButton.classList.contains('is-confirming');
        adminMigrateButton.disabled = true;
        if (adminStatus) adminStatus.textContent = apply ? 'importing…' : 'checking…';
        try {
          const response = await fetch(`${liveServerUrl}/api/admin/sheets/migrate`, {
            method: 'POST',
            headers: {
              authorization: `Bearer ${accountSession.token}`,
              'content-type': 'application/json'
            },
            body: JSON.stringify({ apply })
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.error || 'migration failed');
          if (!apply) {
            adminMigrateButton.classList.add('is-confirming');
            adminMigrateButton.textContent = 'import?';
            if (adminStatus) adminStatus.textContent = `${migrationSummary(payload.migration)}. press import? to confirm.`;
            window.setTimeout(() => {
              adminMigrateButton.classList.remove('is-confirming');
              adminMigrateButton.textContent = 'import existing';
            }, 15000);
          } else {
            adminMigrateButton.classList.remove('is-confirming');
            adminMigrateButton.textContent = 'import existing';
            if (adminStatus) adminStatus.textContent = `${migrationSummary(payload.migration)} imported.`;
            await Promise.all([loadAdminPlayers(), refreshDirectory()]);
          }
        } catch (error) {
          if (adminStatus) adminStatus.textContent = error.message || 'try again.';
        } finally {
          adminMigrateButton.disabled = false;
        }
      }

      async function runMatcher() {
        if (!form || !trigger || !nameInput || !chessInput || !cityInput) return;
        if (accountSession?.player?.kind !== 'account') {
          showSignin();
          return;
        }
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        const chessUsername = normalizeUsername(chessInput.value);
        const username = normalizeUsername(nameInput.value);
        const city = cityInput.value.trim().toLowerCase();
        let cityPlaceId = cityPlaceIdInput?.value || '';
        if ((!cityPlaceId || city !== cityInput.dataset.selectedCity) && await resolveExistingCitySelection(city)) {
          cityPlaceId = cityPlaceIdInput?.value || '';
        }
        if (!cityPlaceId || city !== cityInput.dataset.selectedCity) {
          if (profileIntro) profileIntro.textContent = 'choose your city from the list.';
          cityInput.setCustomValidity('choose a city from the list');
          form.reportValidity();
          cityInput.setCustomValidity('');
          cityInput.focus();
          searchCityOptions();
          return;
        }
        trigger.classList.add('is-working');
        trigger.setAttribute('aria-busy', 'true');
        trigger.textContent = 'saving';

        try {
          const level = accountSession?.player?.placement?.level || '';
          if (privateLevelInput) privateLevelInput.value = level;
          const instagramInput = form.querySelector('[name="instagram_username"]');
          const submittedProfile = {
            username,
            name: username,
            chess: chessUsername,
            city,
            cityPlaceId,
            instagram: normalizeUsername(instagramInput?.value || ''),
            level
          };
          await updateAccountProfile(submittedProfile);
          selectedDirectoryMode = '';
          selectedDirectoryPlayerIds.clear();
          selectedDirectoryLabel = '';
          closeDirectorySelector();
          if (directorySelector) directorySelector.hidden = true;
          if (status) {
            status.textContent = '';
            status.hidden = true;
          }
          results?.classList.remove('is-visible');
          if (results) results.hidden = true;
          directoryProfiles = directoryProfiles.filter((profile) => profile.osbPlayerId !== accountSession.player.id);
          submittedProfile.osbPlayerId = accountSession.player.id;
          if (accountSession.player.directoryVisible !== false) directoryProfiles.push(submittedProfile);
          renderMapMarkers(directoryProfiles);
          renderDirectoryMenu();
          profileSaved = true;
          saveLocalProfile(submittedProfile);
          if (accountSession.player.joined) window.localStorage.setItem('osb-community-joined', 'true');
          trigger.classList.add('is-ready');
          if (profileIntro) profileIntro.textContent = 'saved.';
          trigger.textContent = 'saved';
          trigger.setAttribute('aria-label', 'profile saved');
          trigger.removeAttribute('aria-busy');
          trigger.disabled = true;
          trigger.classList.add('is-confirmation');
          feedbackCue('success');
          window.clearTimeout(saveConfirmationTimer);
          saveConfirmationTimer = window.setTimeout(() => {
            resetMatcherLayout({ immediate: true });
            trigger.disabled = false;
            trigger.classList.remove('is-confirmation');
            trigger.removeAttribute('aria-label');
            if (profileIntro) profileIntro.textContent = 'your one square better profile.';
            updateRequestTrigger();
          }, 1800);
        } catch (error) {
          trigger.classList.add('is-error');
          trigger.removeAttribute('aria-busy');
          feedbackCue('error');
          if (results && status && matches) {
            matches.replaceChildren();
            status.textContent = error instanceof Error ? error.message : 'try again.';
            status.hidden = false;
            closeDirectorySelector();
            if (directorySelector) directorySelector.hidden = true;
            results.hidden = false;
            requestAnimationFrame(() => results.classList.add('is-visible'));
          }
          trigger.textContent = accountSession?.player?.kind === 'account'
            ? 'save'
            : 'join';
          window.setTimeout(() => trigger.classList.remove('is-error'), 1800);
        } finally {
          trigger.classList.remove('is-working');
        }
      }

      scheduleStableMapRender();
      clearMemberDirectory();
      directorySelector?.addEventListener('toggle', () => {
        if (directorySelector.open) renderDirectoryMenu();
      });
      playerSearch?.addEventListener('input', () => {
        playerSearchQuery = playerSearch.value.trim();
        if (selectedDirectoryMode === 'find') {
          showProfileCards(selectedDirectoryProfiles(), 'find friends');
        }
      });
      if (hasSignedInAccount()) {
        refreshDirectory();
        loadMatchRequests();
      }
      updateRequestTrigger();
      updateEmailMatchRequestsButton();
      updateFeedbackButton();
      const directoryRefreshTimer = window.setInterval(() => {
        if (!document.hidden) {
          if (hasSignedInAccount()) {
            refreshDirectory();
          } else {
            clearMemberDirectory();
          }
        }
      }, 15000);
      const requestRefreshTimer = window.setInterval(() => {
        if (!document.hidden && hasSignedInAccount()) loadMatchRequests();
      }, 4000);

      const handleMapResize = () => {
        scheduleStableMapRender();
        positionRequestInbox();
      };
      const handleMapPageShow = () => scheduleStableMapRender();
      const handleMapVisibility = () => {
        if (!document.hidden) scheduleStableMapRender();
      };
      const handleMapOrientation = () => {
        scheduleStableMapRender();
        positionRequestInbox();
      };
      let observedMapWidth = Math.round(map?.getBoundingClientRect().width || 0);
      const mapResizeObserver = typeof ResizeObserver === 'function' && map
        ? new ResizeObserver((entries) => {
            const nextWidth = Math.round(entries[0]?.contentRect?.width || map.getBoundingClientRect().width || 0);
            if (!nextWidth || nextWidth === observedMapWidth) return;
            observedMapWidth = nextWidth;
            scheduleStableMapRender();
          })
        : null;
      mapResizeObserver?.observe(map);
      window.addEventListener('resize', handleMapResize, { passive: true });
      window.addEventListener('pageshow', handleMapPageShow);
      document.addEventListener('visibilitychange', handleMapVisibility);
      window.addEventListener('orientationchange', handleMapOrientation, { passive: true });

      form?.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!panel?.classList.contains('is-open')) {
          hideLivePreview();
          openMatcher(true);
          return;
        }
        runMatcher();
      });

      trigger?.addEventListener('click', () => {
        if (panel?.classList.contains('is-open')) {
          if (accountSession?.player?.kind !== 'account') {
            closeMatcher();
            return;
          }
          form?.requestSubmit();
          return;
        }
        if (accountSession?.player?.kind !== 'account' || !profileSaved) {
          hideLivePreview();
          openMatcher(true);
          return;
        }
        showPlayOptions();
      });

      signinIntent?.addEventListener('click', closeMatcher);

      signinTrigger?.addEventListener('click', () => {
        hideLivePreview();
        openMatcher(true);
      });

      playButton?.addEventListener('click', () => {
        if (accountSession?.player?.kind !== 'account') {
          showLivePreview('computer');
          return;
        }
        hideLivePreview();
        openMatcher(true);
      });

      peopleButton?.addEventListener('click', () => {
        if (!hasSignedInAccount()) return;
        hideLivePreview();
        const directoryIsOpen = Boolean(
          selectedDirectoryMode
          && results
          && !results.hidden
        );
        if (directoryIsOpen) {
          closeDirectoryView();
          return;
        }
        selectDirectoryView('all', 'all');
      });

      requestTriggerButton?.addEventListener('click', () => {
        if (requestDialog?.classList.contains('is-visible')) closeRequestInbox();
        else openRequestInbox();
      });
      livePlayButton?.addEventListener('click', () => showLivePreview('account', true));
      computerPlayButton?.addEventListener('click', () => showLivePreview('computer'));
      learnPlayButton?.addEventListener('click', () => showLivePreview('learn'));
      returnGameButton?.addEventListener('click', () => showLivePreview('account'));
      editProfileButton?.addEventListener('click', editProfile);
      visibilityButton?.addEventListener('click', setDirectoryVisibility);
      emailMatchRequestsButton?.addEventListener('click', setEmailMatchRequests);
      notificationsButton?.addEventListener('click', async () => {
        if (!('Notification' in window) || Notification.permission === 'denied') return;
        markPending(notificationsButton, 'checking');
        const permission = await Notification.requestPermission();
        updateNotificationButton();
        notificationsButton.removeAttribute('aria-busy');
        notificationsButton.classList.remove('is-pending');
        feedbackCue(permission === 'granted' ? 'success' : 'selection');
        if (accountStatus) {
          accountStatus.textContent = permission === 'granted'
            ? 'notifications on.'
            : 'notifications stay off.';
        }
      });
      feedbackButton?.addEventListener('click', async () => {
        feedbackEnabled = !feedbackEnabled;
        try {
          window.localStorage.setItem(feedbackStorageKey, feedbackEnabled ? 'on' : 'off');
        } catch {}
        updateFeedbackButton();
        if (feedbackEnabled) {
          await unlockRequestAudio();
          feedbackCue('success');
        }
        if (accountStatus) accountStatus.textContent = feedbackEnabled
          ? 'sound and haptics on.'
          : 'sound and haptics off.';
      });
      deleteProfileButton?.addEventListener('click', deleteProfile);
      signOutButton?.addEventListener('click', () => signOut());
      adminOpenButton?.addEventListener('click', () => {
        adminDialog?.showModal();
        loadAdminPlayers();
      });
      adminCloseButton?.addEventListener('click', () => adminDialog?.close());
      adminSyncButton?.addEventListener('click', syncAdminSheet);
      adminMigrateButton?.addEventListener('click', migrateExistingSheet);
      adminDialog?.addEventListener('click', (event) => {
        if (event.target === adminDialog) adminDialog.close();
      });
      const handleRequestDismiss = (event) => {
        if (!requestDialog?.classList.contains('is-visible')) return;
        if (event.type === 'keydown' && event.key === 'Escape') {
          closeRequestInbox();
          return;
        }
        if (
          event.type === 'pointerdown'
          && !requestDialog.contains(event.target)
          && !requestTriggerButton?.contains(event.target)
        ) closeRequestInbox();
      };
      document.addEventListener('keydown', handleRequestDismiss);
      document.addEventListener('pointerdown', handleRequestDismiss);

      const handlePlacementProgress = (event) => {
        const nextSession = event.detail?.session;
        const placement = event.detail?.placement;
        if (nextSession?.player?.id === accountSession?.player?.id) rememberAccount(nextSession);
        updatePlacementUi();
        if (!placement?.complete || !profileSaved) return;
        const savedProfile = loadSavedProfile() || {};
        savedProfile.level = placement.level || '';
        saveLocalProfile(savedProfile);
        if (privateLevelInput) privateLevelInput.value = savedProfile.level;
        const currentProfile = directoryProfiles.find((profile) => profile.osbPlayerId === accountSession?.player?.id);
        if (currentProfile) currentProfile.level = savedProfile.level;
      };
      document.addEventListener('osb:placement-progress', handlePlacementProgress);
      const handleIncomingRequest = (event) => {
        notifyIncomingRequest(event.detail?.request);
        loadMatchRequests();
      };
      document.addEventListener('osb:match-request-received', handleIncomingRequest);
      const handleMatchLobbyOpen = () => showLivePreview('account');
      document.addEventListener('osb:match-lobby-open', handleMatchLobbyOpen);
      document.addEventListener('osb:match-requests-refresh', loadMatchRequests);
      const handleDirectGameStart = () => {
        requestInbox = { incoming: [], friendIncoming: [] };
        requestInboxNotice = '';
        requestedPlayerIds.clear();
        outgoingMatchRequests.clear();
        closeRequestInbox();
        updateRequestTrigger();
        showLivePreview('account');
      };
      document.addEventListener('osb:direct-game-start', handleDirectGameStart);
      const handleLiveAccountReady = () => {
        const current = new URL(window.location.href);
        if (current.searchParams.has('request') || current.searchParams.has('response')) {
          applyMatchResponseQuery();
        }
      };
      document.addEventListener('osb:live-account-ready', handleLiveAccountReady);

      const handleFinderHashRoute = () => {
        if (window.location.hash === '#learn' && !livePreviewShown) {
          showLivePreview('learn');
        }
      };
      window.addEventListener('hashchange', handleFinderHashRoute);

      if (window.location.hash === '#play') {
        window.history.replaceState({}, '', window.location.pathname + window.location.search);
      } else if (window.location.hash === '#learn') {
        window.requestAnimationFrame(handleFinderHashRoute);
      }

      const handleFinderPopState = (event) => {
        const historyMode = event.state?.osbLiveChess ? String(event.state.mode || '') : '';
        if (historyMode) {
          if (!livePreviewShown || livePreviewMode !== historyMode) {
            showLivePreview(historyMode, historyMode === 'computer');
          }
          return;
        }
        if (livePreviewShown) returnToMap();
      };
      window.addEventListener('popstate', handleFinderPopState);
      section.addEventListener('selectstart', (event) => {
        if (event.target instanceof Element && event.target.closest('input, textarea')) return;
        event.preventDefault();
      }, true);

      document.addEventListener('pointerdown', unlockRequestAudio, { capture: true });
      document.addEventListener('keydown', unlockRequestAudio, { capture: true });

      section.addEventListener('shopify:section:unload', () => {
        disconnectPresence();
        requestAudioContext?.close?.().catch?.(() => {});
        window.clearTimeout(matcherCloseTimer);
        window.clearTimeout(saveConfirmationTimer);
        window.clearTimeout(deleteConfirmationTimer);
        window.clearTimeout(requestCloseTimer);
        window.clearTimeout(liveTransitionTimer);
        cancelLiveOpenFrames();
        window.cancelAnimationFrame(mapRenderFrame);
        window.cancelAnimationFrame(requestPositionFrame);
        window.clearTimeout(mapRenderRetryTimer);
        window.clearInterval(directoryRefreshTimer);
        window.clearInterval(requestRefreshTimer);
        mapResizeObserver?.disconnect();
        window.removeEventListener('resize', handleMapResize);
        window.removeEventListener('pageshow', handleMapPageShow);
        document.removeEventListener('visibilitychange', handleMapVisibility);
        window.removeEventListener('orientationchange', handleMapOrientation);
        document.removeEventListener('keydown', handleRequestDismiss);
        document.removeEventListener('pointerdown', handleRequestDismiss);
        document.removeEventListener('osb:live-chess-return-map', returnToMap);
        document.removeEventListener('osb:game-presence', handleGamePresence);
        document.removeEventListener('osb:placement-progress', handlePlacementProgress);
        document.removeEventListener('osb:match-request-received', handleIncomingRequest);
        document.removeEventListener('osb:match-lobby-open', handleMatchLobbyOpen);
        document.removeEventListener('osb:match-requests-refresh', loadMatchRequests);
        document.removeEventListener('osb:direct-game-start', handleDirectGameStart);
        document.removeEventListener('osb:live-account-ready', handleLiveAccountReady);
        window.removeEventListener('hashchange', handleFinderHashRoute);
        window.removeEventListener('popstate', handleFinderPopState);
        document.removeEventListener('AppleIDSignInOnSuccess', handleAppleSuccess);
        document.removeEventListener('AppleIDSignInOnFailure', handleAppleFailure);
        document.removeEventListener('pointerdown', unlockRequestAudio, { capture: true });
        document.removeEventListener('keydown', unlockRequestAudio, { capture: true });
        hideSquareCursor();
        window.removeEventListener('blur', hideSquareCursor);
      }, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initOsbFinders());
  } else {
    initOsbFinders();
  }

  document.addEventListener('shopify:section:load', (event) => initOsbFinders(event.target));

  } catch(e) { console.error(e); }
})();
})();
